/* eslint-disable  */
import React, { Fragment, Dispatch, useEffect, useState } from "react";
import "./leftMenu.css";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import HistoryIcon from "@material-ui/icons/History";
import logoicon from "../../assets/mainLogoBlue.png";
import tempKamLogo from "./afg.jpeg"
import smallLogoicon from "../../assets/smallLogoBlue.png";
import NoImage from "../../assets/NoImage.png";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import Tooltip from '@material-ui/core/Tooltip';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import SettingsIcon from "@material-ui/icons/Settings";
import BlurCircularIcon from '@material-ui/icons/BlurCircular';
import ListItemText from "@material-ui/core/ListItemText";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import EmojiEventsOutlinedIcon from "@material-ui/icons/EmojiEventsOutlined";
import CardGiftcard from "@material-ui/icons/CardGiftcard";
import CalendarToday from "@material-ui/icons/CalendarToday";
import PersonIcon from "@material-ui/icons/Person";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import { logout } from "../../store/actions/account.actions";
import { openSideMenu } from "../../store/actions/global.actions";
import { useDispatch, useSelector } from "react-redux";
import { signOut, useUserDispatch } from "../../context/UserContext.js";
import { useHistory } from "react-router-dom";
import LocalMallIcon from '@material-ui/icons/LocalMall';
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';
import RoomIcon from '@material-ui/icons/Room';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { useMsal } from "@azure/msal-react";
import { userAccessControl } from "./UserAccessControl";
import { RESTRICTED_ACCESS } from "../../constants/restrictedAccessConstants";
import LogoutDialog from "./logoutDialog";
import { getProfile, isSellingPrice } from "../../store/actions/profile.action";
import TermsAndConditionsDialog from "./TermsAndConditionsDialog";
import { userTypes } from "../../constants/userTypes";
import { useCallback } from "react";
import { logoutUser } from "../../store/actions/logon.actions";
import { getUniqueEnquirySessionId, resetEnquiryInfo, getTBLPartsAPI, setCustomerChoosePopup } from "../../store/actions/createUpdateEnquiry.actions";
import { getUniqueTimestamp } from "../../common/components/util";
import _ from "lodash";
import { getTermsAndConditions } from "../../store/actions/termsAndConditions.action";
import { profileservice } from "../../services/profile.service";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import WarningIcon from "@material-ui/icons/Warning";
import { Badge, Button } from "@material-ui/core";
import { withStyles, Theme, createStyles, makeStyles, createTheme } from '@material-ui/core/styles';
import { getAgreementDocs, getAllBrands, getAllCreditRequestStatus, setAgreementDetails, setTabValue } from "../../store/actions/dealer.action";
import FullscreenLoader from "../../common/components/FullscreenLoader";
import { EmojiEventsOutlined, PeopleAlt, ViewStreamOutlined } from "@material-ui/icons";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import creditcardicon from '../../assets/creditcard.png';
import SvgIcon from "@material-ui/core/SvgIcon"
import ChooseCustomerDialog from "../CreateEnquiry/ChooseCustomerDialog";
import { getCustomerDetailsByCustomerID, getFSECustomerList } from "../../store/actions/dealer.action";
import Snackbar from './../../common/components/Snackbar';
import { getAllNotifications, getAllOnbardingNotifications, markNotificationRead } from '../../store/actions/notifications.action';
import SupportDialog from "./SupportDialog";
import { get } from 'lodash';
import { getExpiredDocCount, getAccessControlOfBrands } from "../../store/actions/onboard.actions";
import { getDocumentExpiryStatus, getDocumentAccessKamList } from "../../store/actions/profile.action";
import DocumentExpiryStatus from "../Dealers/AddDealer/DocumentExpiryStatus";
import { addNotifications } from '../../store/actions/notifications.action';
import ProductTeamNoImage from "../../assets/alfuttaimAuto.png";
import { getAllAnnexureList } from "../../store/actions/annexureParts.actions";
import ListAltIcon from '@material-ui/icons/ListAlt';
import { getBlackoutNotificationData } from "../../store/actions/announcements.actions";
import BlackoutDialog from "./BlackoutDialog";
import PricingTierDowngradeDialog from "./PricingTierDowngradeDialog";
import { getAnnouncements, getAnnouncementDetail } from '../../store/actions/announcements.actions';
import RefreshIcon from '@material-ui/icons/Refresh';
import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles(() => ({
  icon: {
    float: "left",
    margin: "0 20px 20px 0",
    height: "100%",
    fill: "white",
  },
  toggle: {
    marginLeft: 5,
    width: "115px",
  },
  createButton: {
    backgroundColor: '#1A9FE0',
    width: 140,
    fontWeight: 800,
    textTransform: 'inherit',
    fontFamily: 'Nunito',
    fontSize: '0.688rem',
    color: '#FFFFFF',
    borderRadius: '2.5rem',
    height: 35,
    textAlign: 'center',
    marginRight: 8
  },
  closeButton: {
    backgroundColor: '#EAEAEA',
    width: 140,
    fontWeight: 800,
    textTransform: 'capitalize',
    fontFamily: 'Nunito',
    fontSize: '0.688rem',
    color: '#666666',
    borderRadius: '2.5rem',
    height: 35,
    textAlign: 'center',
    marginRight: 24
  }
}));

const theme = createTheme({
  palette: {
    primary: {
      main: '#1A9FE0'
    },
  },
});

const useStyles2 = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const AntSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 150,
      height: 28,
      padding: 0,
    },
    switchBase: {
      padding: 5,
      color: '#FFFFFF',
    },
    thumb: {
      width: 17,
      height: 17,
    },
    track: {
      background: '#444444',
      opacity: '1 !important',
      borderRadius: '2rem',
      position: 'relative',
      '&:before, &:after': {
        display: 'inline-block',
        position: 'absolute',
        top: '50%',
        width: '50%',
        transform: 'translateY(-50%)',
        color: '#FFFFFF',
        textAlign: 'center',
        fontSize: 11,
        fontFamily: 'Nunito',
        fontWeight: 500
      },
      '&:before': {
        content: '"Purchase Price"',
        left: 7,
        opacity: 0,
      },
      '&:after': {
        content: '"Selling Price"',
        right: 6,
      },
    },
    checked: {
      '&$switchBase': {
        color: '#FFFFFF',
        transform: 'translateX(122px)',
      },
      '& $thumb': {
        backgroundColor: '#FFFFFF',
      },
      '& + $track': {
        '&:before': {
          opacity: 1,
        },
        '&:after': {
          opacity: 0,
        }
      },
    },
  }),
)(Switch);

const List = (props: any) => {
  return (
    <SvgIcon {...props}>
      <path d="M2,6V8H14V6H2M2,10V12H14V10H2M20.04,10.13C19.9,10.13 19.76,10.19 19.65,10.3L18.65,11.3L20.7,13.35L21.7,12.35C21.92,12.14 21.92,11.79 21.7,11.58L20.42,10.3C20.31,10.19 20.18,10.13 20.04,10.13M18.07,11.88L12,17.94V20H14.06L20.12,13.93L18.07,11.88M2,14V16H10V14H2Z"></path>
    </SvgIcon>
  )
}

const LeftMenu: React.FC = () => {
  const [showText, setShowText] = React.useState<any>(false);

  const classes = useStyles();
  const classes2 = useStyles2();
  const [currentUrl, setCurrentUrl] = React.useState<any>(window.location.href);
  const [menuItems, setMenuItems] = React.useState<any>([]);
  const [displayPrice, setDisplayPrice] = React.useState<any>([]);
  const [showAchievements, isShowAchievements] = React.useState<any>(false);
  const [showQuotation, setShowQuotation] = React.useState<any>(false);
  const [limit, setLimit] = React.useState<any>(50);
  const [skip, setSkip] = React.useState<any>(0);
  const [adminMenuItems, setAdminMenuItems] = React.useState<any>([]);
  const history = useHistory();
  const dispatch: Dispatch<any> = useDispatch();
  const userDispatch = useUserDispatch();

  const leftMenuVisibility: any = useSelector(
    (state: any) => state.global && state.global.sideMenuOpened
  );
  const { profileDetails, isSellingPriceData }: any = useSelector((state: any) => state.profileDetails);
  const retriveFeatureAccessibility =
    profileDetails?.data?.data?.accessParameter?.featureAccessibility || [];

  const currentUserType = sessionStorage.getItem('userType');
  const userTypeFromProfile = profileDetails?.data?.data?.basicInfo?.userType;
  const isFSEUser = currentUserType === 'FSE' || userTypeFromProfile === 'FSE';
  const isSubUser = userTypeFromProfile === 'User';
  const profileUserType = String(userTypeFromProfile || '').toLowerCase();
  const isCustomerAdminOrSubUser = profileUserType === 'admin' || profileUserType === 'user';
  const hasSalesReturnAccessForInvoice =
    profileDetails?.data?.data?.customerInfo?.isSalesReturnAccess === true;

  const canDownloadInvoice = isFSEUser
    ? true
    : isCustomerAdminOrSubUser
      ? hasSalesReturnAccessForInvoice
      : !(
        retriveFeatureAccessibility.find(
          (f: { featureCode: string; value: boolean }) => f.featureCode === 'DOWNLOAD_PDF'
        )?.value === false &&
        retriveFeatureAccessibility.find(
          (f: { featureCode: string; value: boolean }) => f.featureCode === 'DOWNLOAD_EXCEL'
        )?.value === false
      );

  const isAnnexurePartAccess = get(profileDetails, 'data.data.customerInfo.isAnnexurePartAccess', '');
  const { isAccessAchievement }: any = useSelector((state: any) => state.achievement);
  const isAdmin: any = useSelector((state: any) => state.global && state.global.isAdmin);
  const [openDeactivatedDialog, setOpenDeactivatedDialog] = React.useState<any>('');
  const [openTradepointAccessDialog, setOpenTradepointAccessDialog] = React.useState<any>('');
  const [openTAndCDialog, setOpenTAndCDialog] = React.useState(false);
  const [showDeactivateDialog, setshowDeactivateDialog] = React.useState<boolean>(false);
  const [expiredCount, setCount] = React.useState(0);
  const [openLogoutDialog, setOpenLogoutDialog] = React.useState(false);
  const sapCustomerId = _.get(profileDetails, "data.data.basicInfo.sapCustomerId", "");
  const isReadTandC = _.get(profileDetails, "data.data.customerInfo.isReadTandC", "");
  // const isAfterLogin: any = useSelector(
  //   (state: any) => state.global && state.global.sideMenuOpened);
  const [userConfirmation, setUserConfirmation] = React.useState<any>(false);
  const { instance } = useMsal();
  const [openChooseCustomerDialog, setOpenChooseCustomerDialog] = React.useState(false);
  const [iwsFseOpenChooseCustomerDialog, setIwsFseOpenChooseCustomerDialog] = React.useState(false);
  const [isOrderEnquiryCreated, setIsOrderEnquiryCreated] = React.useState<boolean>(false);
  const [successMessage, setSuccessMessage] = React.useState<any>(null);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [loading, setLoading] = React.useState<any>(false);
  const [errorMessage, setErrorMessage] = React.useState<any>();
  const { getCustomerDetailsBySapId, getFSECustomerListData }: any = useSelector((state: any) => state.dealer);
  const [getAccInfodata, setGetAccInfodata] = React.useState<any>('');
  const [openCloseSupportDialog, setOpenCloseSupportDialog] = React.useState(false);
  const [assignedKAMs, setAssignedKAMs] = React.useState<any>([]);
  let userTypeByProfileAPI = sessionStorage.getItem('userType-Profile-API');
  const { getDocumentExpiryStatusData }: any = useSelector((state: any) => state.profileDetails);
  const [documentExpiryStatusData, setDocumentExpiryStatusData] = React.useState<any>([]);
  const [access, setAccess] = React.useState(true);
  const blockIntent = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.blockIntent;
  const customerCurrentStatus = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.status;
  const tblDealerAccess = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.featureAccesses;
  // const tblDealerAccess = ["Tyres"];
  const customerTierTypeFromProfile = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.customerTierType;
  const [annexurePartAdded, setAnnexurePartAdded] = React.useState<any>(false);
  const [showBlackoutPopUp, setShowBlackoutPopUp] = React.useState<boolean>(false);
  const [blackOutPopUpData, setBlackoutPopUpData] = React.useState<any>({});
  const [isChooseCustomerOpen, setIsChooseCustomerOpen] = React.useState<any>(false);
  const { showPopup }: any = useSelector((state: any) => state.createUpdateEnquiry);
  const brandPricingTier = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.brandPricingTier;
  const [pricingTierDowngrade, setPricingTierDowngrade] = useState<any>([]);
  const [showPricingTierDialog, setShowPricingTierDialog] = React.useState<boolean>(false);

  function hasAnyGoldPlatinumEliteTier(brandPricingTier: any[]): boolean {
    const allowed = ["gold", "platinum", "elite"];
    return Array.isArray(brandPricingTier) && brandPricingTier.some((b: any) =>
      typeof b.tier === "string" &&
      allowed.some(tier => b.tier.toLowerCase().includes(tier))
    );
  }

  const isSalesReturnAccess: any = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.isSalesReturnAccess;

  const isArchAutoOrg = useCallback(() => {
    const salesOrg = profileDetails?.data?.data?.basicInfo?.salesOrganization;
    return Array.isArray(salesOrg) && salesOrg.some((so: any) => so?.salesOrganization === '2428');
  }, [profileDetails]);

  const shouldShowSalesReturn = useCallback(() => {
    const currentUserType = sessionStorage.getItem('userType');
    const userTypeFromProfile = profileDetails?.data?.data?.basicInfo?.userType;

    // For FSE users
    if (currentUserType === 'FSE' || userTypeFromProfile === 'FSE') {
      const customerTypeAccess = profileDetails?.data?.data?.basicInfo?.customerTypeAccess;

      // Hide Sales Return for FSE if they ONLY have Int. Business access
      if (customerTypeAccess && Array.isArray(customerTypeAccess)) {
        const hasOnlyIntBusiness = customerTypeAccess.length === 1 &&
          customerTypeAccess[0].toLowerCase() === 'intbusiness';
        return !hasOnlyIntBusiness;
      }

      // Default: show for FSE if customerTypeAccess is not available or has other types
      return true;
    }

    // For non-FSE users (Admin, User, etc.) and Int. Business customers
    const customerTierType = profileDetails?.data?.data?.customerInfo?.customerTierType;
    const isSalesReturnAccess = profileDetails?.data?.data?.customerInfo?.isSalesReturnAccess;


    if (customerTierType === 'Int. Business') {
      const salesOrg = profileDetails?.data?.data?.basicInfo?.salesOrganization;
      const isArchAuto = Array.isArray(salesOrg) && salesOrg.some((so: any) => so?.salesOrganization === '2428' && so?.make === 'ARCH_AUTO');
      const isSalesReturnAccess = profileDetails?.data?.data?.customerInfo?.isSalesReturnAccess;
      return isArchAuto && isSalesReturnAccess === true;
    }
    // For all other customer types - check the isSalesReturnAccess flag
    const hasAccess = isSalesReturnAccess === true;
    return hasAccess;
  }, [profileDetails]);

  useEffect(() => {
    if (!isAdmin) {
      userAccessControl(profileDetails);
    }
  }, [isAdmin, profileDetails])

  React.useEffect(() => {
    if (showPopup && (sessionStorage.getItem('userType') === 'FSE' || userType === "FSE" || sessionStorage.getItem('userType') === 'sre')) {
      handleChooseCustomer()
    } else {
      setOpenChooseCustomerDialog(false);
    }
  }, [showPopup])

  const restrictedSideMenuItems = sessionStorage.getItem('restrictFeat');
  const showCreateChangeEnquiry = !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.CREATE_CHANGE_ENQUIRY);
  const openChosseCustomer = sessionStorage.getItem('openChosseCustomer');

  let sideMenuItems = [
    {
      featureCode: "ACHIEVEMENTS",
      icon: <EmojiEventsOutlined fontSize="inherit" />,
      name: "Achievements",
      route: "achievements",
    },
    {
      featureCode: "DASHBOARD",
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      featureCode: "ENQ_LIST",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Order Enquiry",
      route: "orderenquiry",
    },
    {
      featureCode: "ORD_LIST",
      icon: <LocalMallOutlinedIcon fontSize="inherit" />,
      name: "Order History",
      route: "orderhistory",
    },
    {
      featureCode: "SALES_RETURN",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Sales Return",
      route: "returnorder",
    },
    // {
    //   featureCode: "ARC_LIST",
    //   icon: <LocalMallOutlinedIcon fontSize="inherit" />,
    //   name: "Archived Data",
    //   route: "archiveddata",
    // },
    {
      featureCode: "QUO_LIST",
      icon: <List fontSize="inherit" />,
      name: "Quotation",
      route: "quotation",
    },
    {
      featureCode: "LIST_FAVORIT",
      icon: <FavoriteBorderIcon fontSize="inherit" />,
      name: "Favorites",
      route: "favorites",
    },
    {
      featureCode: "FIND_SUPERSESSION",
      icon: <HistoryIcon fontSize="inherit" />,
      name: "Supersession",
      route: "partshistory",
    },
    {
      featureCode: "SPECIAL_OFFERS",
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "specialofferdetail",
    },
    {
      featureCode: "ORG_SETTINGS",
      icon: <SettingsIcon fontSize="inherit" />,
      name: "Org. Setting",
      route: "orgsetting",
    },
    {
      featureCode: "WEM",
      icon: <BlurCircularIcon fontSize="inherit" />,
      name: "Workshop Equipment Materials",
      route: "workshopmaterials",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),

    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "profile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  let dealerSideMenuItems = [
    {
      featureCode: "ACHIEVEMENTS",
      icon: <EmojiEventsOutlined fontSize="inherit" />,
      name: "Achievements",
      route: "achievements",
    },
    {
      featureCode: "DASHBOARD",
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      featureCode: "ENQ_LIST",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Order Enquiry",
      route: "orderenquiry",
    },
    {
      featureCode: "ORD_LIST",
      icon: <LocalMallOutlinedIcon fontSize="inherit" />,
      name: "Order History",
      route: "orderhistory",
    },
    {
      featureCode: "SALES_RETURN",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Sales Return",
      route: "returnorder",
    },
    // {
    //   featureCode: "ARC_LIST",
    //   icon: <LocalMallOutlinedIcon fontSize="inherit" />,
    //   name: "Archived Data",
    //   route: "archiveddata",
    // },
    // {
    //   featureCode: "QUO_LIST",
    //   icon: <List fontSize="inherit" />,
    //   name: "Quotation",
    //   route: "quotation",
    // },
    {
      featureCode: "LIST_FAVORIT",
      icon: <FavoriteBorderIcon fontSize="inherit" />,
      name: "Favorites",
      route: "favorites",
    },
    {
      featureCode: "FIND_SUPERSESSION",
      icon: <HistoryIcon fontSize="inherit" />,
      name: "Supersession",
      route: "partshistory",
    },
    {
      featureCode: "SPECIAL_OFFERS",
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "specialofferdetail",
    },
    {
      featureCode: "ORG_SETTINGS",
      icon: <SettingsIcon fontSize="inherit" />,
      name: "Org. Setting",
      route: "orgsetting",
    },
    {
      featureCode: "WEM",
      icon: <BlurCircularIcon fontSize="inherit" />,
      name: "Workshop Equipment Materials",
      route: "workshopmaterials",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),

    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "profile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  let dealerAnnexureSideMenuItems = [
    {
      featureCode: "ACHIEVEMENTS",
      icon: <EmojiEventsOutlined fontSize="inherit" />,
      name: "Achievements",
      route: "achievements",
    },
    {
      featureCode: "DASHBOARD",
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      featureCode: "ENQ_LIST",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Order Enquiry",
      route: "annexurecreateenquiry",
    },
    {
      featureCode: "ORD_LIST",
      icon: <LocalMallOutlinedIcon fontSize="inherit" />,
      name: "Order History",
      route: "orderhistory",
    },
    {
      featureCode: "SALES_RETURN",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Sales Return",
      route: "returnorder",
    },
    // {
    //   featureCode: "ARC_LIST",
    //   icon: <LocalMallOutlinedIcon fontSize="inherit" />,
    //   name: "Archived Data",
    //   route: "archiveddata",
    // },
    // {
    //   featureCode: "QUO_LIST",
    //   icon: <List fontSize="inherit" />,
    //   name: "Quotation",
    //   route: "quotation",
    // },
    {
      featureCode: "LIST_FAVORIT",
      icon: <FavoriteBorderIcon fontSize="inherit" />,
      name: "Favorites",
      route: "favorites",
    },
    {
      featureCode: "FIND_SUPERSESSION",
      icon: <HistoryIcon fontSize="inherit" />,
      name: "Supersession",
      route: "partshistory",
    },
    {
      featureCode: "SPECIAL_OFFERS",
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "specialofferdetail",
    },
    {
      featureCode: "ORG_SETTINGS",
      icon: <SettingsIcon fontSize="inherit" />,
      name: "Org. Setting",
      route: "orgsetting",
    },
    {
      featureCode: "WEM",
      icon: <BlurCircularIcon fontSize="inherit" />,
      name: "Workshop Equipment Materials",
      route: "workshopmaterials",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),

    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "profile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  let ibSideMenuItems = [
    {
      featureCode: "ACHIEVEMENTS",
      icon: <EmojiEventsOutlined fontSize="inherit" />,
      name: "Achievements",
      route: "achievements",
    },
    {
      featureCode: "DASHBOARD",
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      featureCode: "ENQ_LIST",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Order Enquiry",
      route: "orderenquiry",
    },
    {
      featureCode: "ORD_LIST",
      icon: <LocalMallOutlinedIcon fontSize="inherit" />,
      name: "Order History",
      route: "orderhistory",
    },
    {
      featureCode: "SALES_RETURN",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Sales Return",
      route: "returnorder",
    },
    // {
    //   featureCode: "ARC_LIST",
    //   icon: <LocalMallOutlinedIcon fontSize="inherit" />,
    //   name: "Archived Data",
    //   route: "archiveddata",
    // },
    // {
    //   featureCode: "QUO_LIST",
    //   icon: <List fontSize="inherit" />,
    //   name: "Quotation",
    //   route: "quotation",
    // },
    {
      featureCode: "LIST_FAVORIT",
      icon: <FavoriteBorderIcon fontSize="inherit" />,
      name: "Favorites",
      route: "favorites",
    },
    {
      featureCode: "FIND_SUPERSESSION",
      icon: <HistoryIcon fontSize="inherit" />,
      name: "Supersession",
      route: "partshistory",
    },
    {
      featureCode: "SPECIAL_OFFERS",
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "specialofferdetail",
    },
    {
      featureCode: "ORG_SETTINGS",
      icon: <SettingsIcon fontSize="inherit" />,
      name: "Org. Setting",
      route: "orgsetting",
    },
    {
      featureCode: "WEM",
      icon: <BlurCircularIcon fontSize="inherit" />,
      name: "Workshop Equipment Materials",
      route: "workshopmaterials",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),

    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "profile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  let ProductTeamSideMenuItems = [
    {
      featureCode: "product_team",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" className="icon-svg">
          <g id="checklist" transform="translate(-0.251)">
            <path id="Path_19" data-name="Path 19" d="M60.979,142.5a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -134.828)" />
            <path id="Path_20" data-name="Path 20" d="M170.368,182.345h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -175.562)" />
            <path id="Path_21" data-name="Path 21" d="M66.3,244.5H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -235.406)" />
            <path id="Path_22" data-name="Path 22" d="M60.979,314.275a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -300.186)" />
            <path id="Path_23" data-name="Path 23" d="M170.368,354.07h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -340.9)" />
            <path id="Path_24" data-name="Path 24" d="M66.3,415.337H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -399.758)" />
            <path id="Path_25" data-name="Path 25" d="M17.893,0H7.291A.973.973,0,0,0,6.95.067,1.833,1.833,0,0,0,6.605.034,1.814,1.814,0,0,0,4.888,1.261h-.6A.794.794,0,0,0,3.5,2H1.538A1.287,1.287,0,0,0,.251,3.286v14.43A1.287,1.287,0,0,0,1.538,19H11.672a1.289,1.289,0,0,0,1.242-.95h5.072a1.38,1.38,0,0,0,1.265-1.355V1.355A1.358,1.358,0,0,0,17.893,0ZM4.612,2.373H5.35a.556.556,0,0,0,.557-.545.7.7,0,0,1,1.4,0,.556.556,0,0,0,.557.545H8.6v.612H4.612Zm7.233,15.343a.173.173,0,0,1-.173.173H1.538a.173.173,0,0,1-.173-.173V3.286a.173.173,0,0,1,.173-.173H3.5v.118a.867.867,0,0,0,.867.865H8.845a.867.867,0,0,0,.867-.865V3.113h1.961a.173.173,0,0,1,.173.173Zm6.292-1.021a.243.243,0,0,1-.216.242l-.016,0H12.959V3.286A1.287,1.287,0,0,0,11.672,2H9.708a.8.8,0,0,0-.8-.74H8.322c-.017-.051-.038-.1-.059-.15h9.63a.245.245,0,0,1,.245.244Z" transform="translate(0)" />
          </g>
        </svg>
      ),
      name: "OEM/IAM Mapping",
      route: "oesoemmapping",
    },


    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  let SREMenuItems = [
    {
      featureCode: "SALES_RETURN",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Sales Return",
      route: "returnorder",
    },
    {
      featureCode: "ENQ_LIST",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Order Enquiry",
      route: "orderenquiry",
    },
    {
      featureCode: "ORD_LIST",
      icon: <LocalMallOutlinedIcon fontSize="inherit" />,
      name: "Order History",
      route: "orderhistory",
    },
    {
      featureCode: "RETURN_REQUEST",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Review Return Request",
      route: "returnrequest",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),
    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  let sideMenuItemsForTBLFSE = [
    {
      featureCode: "DASHBOARD",
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      icon: <PersonOutlineIcon fontSize="inherit" />,
      name: "Customers",
      route: "dealers",
    },
    {
      featureCode: "ENQ_LIST",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Order Enquiry",
      route: "orderenquiry",
    },
    {
      featureCode: "ORD_LIST",
      icon: <LocalMallOutlinedIcon fontSize="inherit" />,
      name: "Order History",
      route: "orderhistory",
    },
    {
      featureCode: "RETURN_REQUEST",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Review Return Request",
      route: "returnrequest",
    },
    {
      featureCode: "SALES_RETURN",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Sales Return",
      route: "returnorder",
    },
    {
      featureCode: "QUO_LIST",
      icon: <List fontSize="inherit" />,
      name: "Quotation",
      route: "quotation",
    },
    {
      featureCode: "product_team",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" className="icon-svg">
          <g id="checklist" transform="translate(-0.251)">
            <path id="Path_19" data-name="Path 19" d="M60.979,142.5a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -134.828)" />
            <path id="Path_20" data-name="Path 20" d="M170.368,182.345h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -175.562)" />
            <path id="Path_21" data-name="Path 21" d="M66.3,244.5H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -235.406)" />
            <path id="Path_22" data-name="Path 22" d="M60.979,314.275a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -300.186)" />
            <path id="Path_23" data-name="Path 23" d="M170.368,354.07h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -340.9)" />
            <path id="Path_24" data-name="Path 24" d="M66.3,415.337H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -399.758)" />
            <path id="Path_25" data-name="Path 25" d="M17.893,0H7.291A.973.973,0,0,0,6.95.067,1.833,1.833,0,0,0,6.605.034,1.814,1.814,0,0,0,4.888,1.261h-.6A.794.794,0,0,0,3.5,2H1.538A1.287,1.287,0,0,0,.251,3.286v14.43A1.287,1.287,0,0,0,1.538,19H11.672a1.289,1.289,0,0,0,1.242-.95h5.072a1.38,1.38,0,0,0,1.265-1.355V1.355A1.358,1.358,0,0,0,17.893,0ZM4.612,2.373H5.35a.556.556,0,0,0,.557-.545.7.7,0,0,1,1.4,0,.556.556,0,0,0,.557.545H8.6v.612H4.612Zm7.233,15.343a.173.173,0,0,1-.173.173H1.538a.173.173,0,0,1-.173-.173V3.286a.173.173,0,0,1,.173-.173H3.5v.118a.867.867,0,0,0,.867.865H8.845a.867.867,0,0,0,.867-.865V3.113h1.961a.173.173,0,0,1,.173.173Zm6.292-1.021a.243.243,0,0,1-.216.242l-.016,0H12.959V3.286A1.287,1.287,0,0,0,11.672,2H9.708a.8.8,0,0,0-.8-.74H8.322c-.017-.051-.038-.1-.059-.15h9.63a.245.245,0,0,1,.245.244Z" transform="translate(0)" />
          </g>
        </svg>
      ),
      name: "OEM/IAM Mapping",
      route: "oesoemmapping",
    },
    {
      featureCode: "SPECIAL_OFFERS",
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "specialofferdetail",
    },
    {
      featureCode: "WEM",
      icon: <BlurCircularIcon fontSize="inherit" />,
      name: "Workshop Equipment Materials",
      route: "workshopmaterials",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),

    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "profile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];


  let tblDealerPartsSideMenuItems = [
    {
      featureCode: "DASHBOARD",
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      featureCode: "ENQ_LIST",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Order Enquiry",
      route: "orderenquiry",
    },
    {
      featureCode: "ORD_LIST",
      icon: <LocalMallOutlinedIcon fontSize="inherit" />,
      name: "Order History",
      route: "orderhistory",
    },
    {
      featureCode: "SALES_RETURN",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Sales Return",
      route: "returnorder",
    },
    {
      featureCode: "LIST_FAVORIT",
      icon: <FavoriteBorderIcon fontSize="inherit" />,
      name: "Favorites",
      route: "favorites",
    },
    {
      featureCode: "FIND_SUPERSESSION",
      icon: <HistoryIcon fontSize="inherit" />,
      name: "Supersession",
      route: "partshistory",
    },
    {
      featureCode: "SPECIAL_OFFERS",
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "specialofferdetail",
    },
    {
      featureCode: "ORG_SETTINGS",
      icon: <SettingsIcon fontSize="inherit" />,
      name: "Org. Setting",
      route: "orgsetting",
    },
    {
      featureCode: "WEM",
      icon: <BlurCircularIcon fontSize="inherit" />,
      name: "Workshop Equipment Materials",
      route: "workshopmaterials",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),

    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "profile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  let tblDealerTyresSideMenuItems = [
    {
      featureCode: "DASHBOARD",
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      featureCode: "ENQ_LIST",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Order Enquiry",
      route: "orderenquiry",
    },
    {
      featureCode: "ORD_LIST",
      icon: <LocalMallOutlinedIcon fontSize="inherit" />,
      name: "Order History",
      route: "orderhistory",
    },
    {
      featureCode: "SALES_RETURN",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Sales Return",
      route: "returnorder",
    },
    {
      featureCode: "LIST_FAVORIT",
      icon: <FavoriteBorderIcon fontSize="inherit" />,
      name: "Favorites",
      route: "favorites",
    },
    {
      featureCode: "SPECIAL_OFFERS",
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "specialofferdetail",
    },
    {
      featureCode: "ORG_SETTINGS",
      icon: <SettingsIcon fontSize="inherit" />,
      name: "Org. Setting",
      route: "orgsetting",
    },
    {
      featureCode: "WEM",
      icon: <BlurCircularIcon fontSize="inherit" />,
      name: "Workshop Equipment Materials",
      route: "workshopmaterials",
    }, ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),

    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "profile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  let workshopSideMenuItems = [
    {
      featureCode: "ACHIEVEMENTS",
      icon: <EmojiEventsOutlined fontSize="inherit" />,
      name: "Achievements",
      route: "achievements",
    },
    {
      featureCode: "DASHBOARD",
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      featureCode: "ENQ_LIST",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Order Enquiry",
      route: "orderenquiry",
    },
    {
      featureCode: "ORD_LIST",
      icon: <LocalMallOutlinedIcon fontSize="inherit" />,
      name: "Order History",
      route: "orderhistory",
    },
    {
      featureCode: "SALES_RETURN",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Sales Return",
      route: "returnorder",
    },
    // {
    //   featureCode: "ARC_LIST",
    //   icon: <LocalMallOutlinedIcon fontSize="inherit" />,
    //   name: "Archived Data",
    //   route: "archiveddata",
    // },
    // {
    //   featureCode: "CAT-LOG",
    //   icon: <img src="./catalogue.svg" style={{ fill: "#757575", height: "1.3rem", width: "1.3rem", opacity: "0.5" }} />,
    //   name: "Catalogue",
    //   route: "#",
    // },
    {
      featureCode: "LIST_FAVORIT",
      icon: <FavoriteBorderIcon fontSize="inherit" />,
      name: "Favorites",
      route: "favorites",
    },
    {
      featureCode: "FIND_SUPERSESSION",
      icon: <HistoryIcon fontSize="inherit" />,
      name: "Supersession",
      route: "partshistory",
    },
    {
      featureCode: "SPECIAL_OFFERS",
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "specialofferdetail",
    },
    {
      featureCode: "ORG_SETTINGS",
      icon: <SettingsIcon fontSize="inherit" />,
      name: "Org. Setting",
      route: "orgsetting",
    },
    {
      featureCode: "WEM",
      icon: <BlurCircularIcon fontSize="inherit" />,
      name: "Workshop Equipment Materials",
      route: "workshopmaterials",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),

    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "profile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  let onBoardMenuItems = [
    {
      featureCode: "ORG_SETTINGS",
      icon: <SettingsIcon fontSize="inherit" />,
      name: "Complete Registration",
      route: "onboarding",
    },
    // {
    //   featureCode: "SHIP_TO_PARTY",
    //   icon: <RoomIcon fontSize="inherit" />,
    //   name: "Ship to Party",
    //   route: "shiptoparty",
    // },
    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "profile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  // USER ADDED BY KAM FOR CONFIRMATION OF INFO
  let onBoardMenuItemsForUserConfirmation = [
    {
      featureCode: "ORG_SETTINGS",
      icon: <SettingsIcon fontSize="inherit" />,
      name: "Complete Registration",
      route: "onboarding",
    },
    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "profile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  let creditRequestMenuItems = [

    {
      featureCode: "ORD_LIST",
      icon: <LocalMallIcon fontSize="inherit" />,
      name: "Credit Request",
      route: "creditteam",
    },
    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  // SUPER ADMIN LEFT - MENU ITEMS 
  let superAdminMenuItems = [
    {
      featureCode: "PLAN_FEATURES",
      icon: <PersonOutlineIcon fontSize="inherit" />,
      name: "Plan Features",
      route: "planfeatures",
    },
    {
      featureCode: "SET_TARGET",
      icon: <img src="./settarget.svg" />,
      selectedIcon: <img src="./settargetinfo.svg" />,
      name: "Set Target",
      route: "settarget",
    },
    {
      featureCode: "DEALERS",
      icon: <PeopleAlt fontSize="inherit" />,
      name: "Customers",
      route: "superadmindealers",
    },
    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  //Special Price Request Menuitems
  let specialPriceRequest = [
    {
      featureCode: "SPECIAL_PRICE_REQUEST",
      icon: <CardGiftcard fontSize="inherit" />,
      name: "Special Price Request",
      route: "specialpricerequest",
    },
    {
      featureCode: "ANNEXURE_PART",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Annexure/Core Product List",
      route: "annexurePartList",
    },
    {
      featureCode: "MY_SCHEDULE",
      icon: <CalendarToday fontSize="inherit" />,
      name: "My Schedule",
      route: "myschedule",
    },
    {
      featureCode: "MY_PROFILE",
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      featureCode: "LOGOUT",
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    }
  ];


  if (restrictedSideMenuItems) {
    sideMenuItems = sideMenuItems.filter((item: any) => {
      const shouldKeep = !restrictedSideMenuItems?.includes(item.featureCode);
      return shouldKeep;
    })

    dealerSideMenuItems = dealerSideMenuItems.filter((item: any) => {
      const shouldKeep = !restrictedSideMenuItems?.includes(item.featureCode);
      return shouldKeep;
    })

    dealerAnnexureSideMenuItems = dealerAnnexureSideMenuItems.filter((item: any) => {
      const shouldKeep = !restrictedSideMenuItems?.includes(item.featureCode);
      return shouldKeep;
    })

    workshopSideMenuItems = workshopSideMenuItems.filter((item: any) => {
      const shouldKeep = !restrictedSideMenuItems?.includes(item.featureCode);
      return shouldKeep;
    })

    ibSideMenuItems = ibSideMenuItems.filter((item: any) => {
      const shouldKeep = !restrictedSideMenuItems?.includes(item.featureCode);
      return shouldKeep;
    })

    tblDealerPartsSideMenuItems = tblDealerPartsSideMenuItems.filter((item: any) => {
      const shouldKeep = !restrictedSideMenuItems?.includes(item.featureCode);
      return shouldKeep;
    })

    tblDealerTyresSideMenuItems = tblDealerTyresSideMenuItems.filter((item: any) => {
      const shouldKeep = !restrictedSideMenuItems?.includes(item.featureCode);
      return shouldKeep;
    })

    ProductTeamSideMenuItems = ProductTeamSideMenuItems.filter((item: any) => {
      const shouldKeep = !restrictedSideMenuItems?.includes(item.featureCode);
      return shouldKeep;
    })
  }

  // const shouldShowAnnexure = hasAnyGoldPlatinumEliteTier(brandPricingTier);

  // // For each menu you render, filter Annexure out if not allowed
  // const filteredDealerMenuItems = (dealerSideMenuItems || []).filter(
  //   item => shouldShowAnnexure || item.featureCode !== 'ANNEXUREPART'
  // );
  // const filteredDealerAnnexureMenuItems = (dealerAnnexureSideMenuItems || []).filter(
  //   item => shouldShowAnnexure || item.featureCode !== 'ANNEXUREPART'
  // );

  // const userTypeForTier = (sessionStorage.getItem("userType") || "").toLowerCase();

  // React.useEffect(() => {
  //   // Only popup for DEALER or other allowed user types (not KAM or FSE)
  //   if (
  //     Array.isArray(brandPricingTier) &&
  //     brandPricingTier.length > 0 &&
  //     !hasAnyGoldPlatinumEliteTier(brandPricingTier) &&
  //     userTypeForTier !== "kam" &&
  //     userTypeForTier !== "fse"
  //   ) {
  //     setShowPricingTierDialog(false);
  //   } else {
  //     setShowPricingTierDialog(false);
  //   }
  // }, [brandPricingTier, userTypeForTier]);


  const adminSideMenuItems = [
    {
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      icon: <PersonOutlineIcon fontSize="inherit" />,
      name: "Customers",
      route: "dealers",
    },
    {
      featureCode: "product_team",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" className="icon-svg">
          <g id="checklist" transform="translate(-0.251)">
            <path id="Path_19" data-name="Path 19" d="M60.979,142.5a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -134.828)" />
            <path id="Path_20" data-name="Path 20" d="M170.368,182.345h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -175.562)" />
            <path id="Path_21" data-name="Path 21" d="M66.3,244.5H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -235.406)" />
            <path id="Path_22" data-name="Path 22" d="M60.979,314.275a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -300.186)" />
            <path id="Path_23" data-name="Path 23" d="M170.368,354.07h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -340.9)" />
            <path id="Path_24" data-name="Path 24" d="M66.3,415.337H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -399.758)" />
            <path id="Path_25" data-name="Path 25" d="M17.893,0H7.291A.973.973,0,0,0,6.95.067,1.833,1.833,0,0,0,6.605.034,1.814,1.814,0,0,0,4.888,1.261h-.6A.794.794,0,0,0,3.5,2H1.538A1.287,1.287,0,0,0,.251,3.286v14.43A1.287,1.287,0,0,0,1.538,19H11.672a1.289,1.289,0,0,0,1.242-.95h5.072a1.38,1.38,0,0,0,1.265-1.355V1.355A1.358,1.358,0,0,0,17.893,0ZM4.612,2.373H5.35a.556.556,0,0,0,.557-.545.7.7,0,0,1,1.4,0,.556.556,0,0,0,.557.545H8.6v.612H4.612Zm7.233,15.343a.173.173,0,0,1-.173.173H1.538a.173.173,0,0,1-.173-.173V3.286a.173.173,0,0,1,.173-.173H3.5v.118a.867.867,0,0,0,.867.865H8.845a.867.867,0,0,0,.867-.865V3.113h1.961a.173.173,0,0,1,.173.173Zm6.292-1.021a.243.243,0,0,1-.216.242l-.016,0H12.959V3.286A1.287,1.287,0,0,0,11.672,2H9.708a.8.8,0,0,0-.8-.74H8.322c-.017-.051-.038-.1-.059-.15h9.63a.245.245,0,0,1,.245.244Z" transform="translate(0)" />
          </g>
        </svg>
      ),
      name: "OEM/IAM Mapping",
      route: "oesoemmapping",
    },
    // {
    //   featureCode: "ANNEXURE_PART",
    //   icon: <AssignmentOutlinedIcon fontSize="inherit" />,
    //   name: "Annexure/Core Product List",
    //   route: "annexurePartList",
    // },
    {
      icon: <CardGiftcard fontSize="inherit" />,
      name: "Special Price Request",
      route: "specialpricekam",
    },
    {
      icon: <CreditCardIcon fontSize="inherit" />,
      name: "Credit Request",
      route: "creditlist",
    },
    {
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "adminspecialoffers",
    },
    {
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  const adminSideMenuItemsDealerKam = [
    {
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      icon: <PersonOutlineIcon fontSize="inherit" />,
      name: "Customers",
      route: "dealers",
    },
    {
      featureCode: "product_team",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" className="icon-svg">
          <g id="checklist" transform="translate(-0.251)">
            <path id="Path_19" data-name="Path 19" d="M60.979,142.5a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -134.828)" />
            <path id="Path_20" data-name="Path 20" d="M170.368,182.345h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -175.562)" />
            <path id="Path_21" data-name="Path 21" d="M66.3,244.5H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -235.406)" />
            <path id="Path_22" data-name="Path 22" d="M60.979,314.275a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -300.186)" />
            <path id="Path_23" data-name="Path 23" d="M170.368,354.07h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -340.9)" />
            <path id="Path_24" data-name="Path 24" d="M66.3,415.337H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -399.758)" />
            <path id="Path_25" data-name="Path 25" d="M17.893,0H7.291A.973.973,0,0,0,6.95.067,1.833,1.833,0,0,0,6.605.034,1.814,1.814,0,0,0,4.888,1.261h-.6A.794.794,0,0,0,3.5,2H1.538A1.287,1.287,0,0,0,.251,3.286v14.43A1.287,1.287,0,0,0,1.538,19H11.672a1.289,1.289,0,0,0,1.242-.95h5.072a1.38,1.38,0,0,0,1.265-1.355V1.355A1.358,1.358,0,0,0,17.893,0ZM4.612,2.373H5.35a.556.556,0,0,0,.557-.545.7.7,0,0,1,1.4,0,.556.556,0,0,0,.557.545H8.6v.612H4.612Zm7.233,15.343a.173.173,0,0,1-.173.173H1.538a.173.173,0,0,1-.173-.173V3.286a.173.173,0,0,1,.173-.173H3.5v.118a.867.867,0,0,0,.867.865H8.845a.867.867,0,0,0,.867-.865V3.113h1.961a.173.173,0,0,1,.173.173Zm6.292-1.021a.243.243,0,0,1-.216.242l-.016,0H12.959V3.286A1.287,1.287,0,0,0,11.672,2H9.708a.8.8,0,0,0-.8-.74H8.322c-.017-.051-.038-.1-.059-.15h9.63a.245.245,0,0,1,.245.244Z" transform="translate(0)" />
          </g>
        </svg>
      ),
      name: "OEM/IAM Mapping",
      route: "oesoemmapping",
    },
    {
      featureCode: "ANNEXURE_PART",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Annexure/Core Product List",
      route: "annexurePartList",
    },
    {
      icon: <CardGiftcard fontSize="inherit" />,
      name: "Special Price Request",
      route: "specialpricekam",
    },
    {
      icon: <CreditCardIcon fontSize="inherit" />,
      name: "Credit Request",
      route: "creditlist",
    },
    {
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "adminspecialoffers",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),

    {
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  const adminSideMenuItemsKAM = [
    {
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      icon: <PersonOutlineIcon fontSize="inherit" />,
      name: "Customers",
      route: "dealers",
    },
    {
      featureCode: "product_team",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" className="icon-svg">
          <g id="checklist" transform="translate(-0.251)">
            <path id="Path_19" data-name="Path 19" d="M60.979,142.5a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -134.828)" />
            <path id="Path_20" data-name="Path 20" d="M170.368,182.345h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -175.562)" />
            <path id="Path_21" data-name="Path 21" d="M66.3,244.5H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -235.406)" />
            <path id="Path_22" data-name="Path 22" d="M60.979,314.275a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -300.186)" />
            <path id="Path_23" data-name="Path 23" d="M170.368,354.07h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -340.9)" />
            <path id="Path_24" data-name="Path 24" d="M66.3,415.337H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -399.758)" />
            <path id="Path_25" data-name="Path 25" d="M17.893,0H7.291A.973.973,0,0,0,6.95.067,1.833,1.833,0,0,0,6.605.034,1.814,1.814,0,0,0,4.888,1.261h-.6A.794.794,0,0,0,3.5,2H1.538A1.287,1.287,0,0,0,.251,3.286v14.43A1.287,1.287,0,0,0,1.538,19H11.672a1.289,1.289,0,0,0,1.242-.95h5.072a1.38,1.38,0,0,0,1.265-1.355V1.355A1.358,1.358,0,0,0,17.893,0ZM4.612,2.373H5.35a.556.556,0,0,0,.557-.545.7.7,0,0,1,1.4,0,.556.556,0,0,0,.557.545H8.6v.612H4.612Zm7.233,15.343a.173.173,0,0,1-.173.173H1.538a.173.173,0,0,1-.173-.173V3.286a.173.173,0,0,1,.173-.173H3.5v.118a.867.867,0,0,0,.867.865H8.845a.867.867,0,0,0,.867-.865V3.113h1.961a.173.173,0,0,1,.173.173Zm6.292-1.021a.243.243,0,0,1-.216.242l-.016,0H12.959V3.286A1.287,1.287,0,0,0,11.672,2H9.708a.8.8,0,0,0-.8-.74H8.322c-.017-.051-.038-.1-.059-.15h9.63a.245.245,0,0,1,.245.244Z" transform="translate(0)" />
          </g>
        </svg>
      ),
      name: "OEM/IAM Mapping",
      route: "oesoemmapping",
    },
    {
      featureCode: "ANNEXURE_PART",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Annexure/Core Product List",
      route: "annexurePartList",
    },
    {
      icon: <CardGiftcard fontSize="inherit" />,
      name: "Special Price Request",
      route: "specialpricekam",
    },
    {
      icon: <CreditCardIcon fontSize="inherit" />,
      name: "Credit Request",
      route: "creditlist",
    },
    {
      icon: <ListAltIcon fontSize="inherit" />,
      name: "Manage Stock",
      route: "managestock",
    },
    {
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "adminspecialoffers",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),

    {
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  const adminSideMenuItemsTBLKAM = [
    {
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      icon: <PersonOutlineIcon fontSize="inherit" />,
      name: "Customers",
      route: "dealers",
    },
    {
      featureCode: "product_team",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" className="icon-svg">
          <g id="checklist" transform="translate(-0.251)">
            <path id="Path_19" data-name="Path 19" d="M60.979,142.5a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -134.828)" />
            <path id="Path_20" data-name="Path 20" d="M170.368,182.345h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -175.562)" />
            <path id="Path_21" data-name="Path 21" d="M66.3,244.5H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -235.406)" />
            <path id="Path_22" data-name="Path 22" d="M60.979,314.275a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -300.186)" />
            <path id="Path_23" data-name="Path 23" d="M170.368,354.07h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -340.9)" />
            <path id="Path_24" data-name="Path 24" d="M66.3,415.337H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -399.758)" />
            <path id="Path_25" data-name="Path 25" d="M17.893,0H7.291A.973.973,0,0,0,6.95.067,1.833,1.833,0,0,0,6.605.034,1.814,1.814,0,0,0,4.888,1.261h-.6A.794.794,0,0,0,3.5,2H1.538A1.287,1.287,0,0,0,.251,3.286v14.43A1.287,1.287,0,0,0,1.538,19H11.672a1.289,1.289,0,0,0,1.242-.95h5.072a1.38,1.38,0,0,0,1.265-1.355V1.355A1.358,1.358,0,0,0,17.893,0ZM4.612,2.373H5.35a.556.556,0,0,0,.557-.545.7.7,0,0,1,1.4,0,.556.556,0,0,0,.557.545H8.6v.612H4.612Zm7.233,15.343a.173.173,0,0,1-.173.173H1.538a.173.173,0,0,1-.173-.173V3.286a.173.173,0,0,1,.173-.173H3.5v.118a.867.867,0,0,0,.867.865H8.845a.867.867,0,0,0,.867-.865V3.113h1.961a.173.173,0,0,1,.173.173Zm6.292-1.021a.243.243,0,0,1-.216.242l-.016,0H12.959V3.286A1.287,1.287,0,0,0,11.672,2H9.708a.8.8,0,0,0-.8-.74H8.322c-.017-.051-.038-.1-.059-.15h9.63a.245.245,0,0,1,.245.244Z" transform="translate(0)" />
          </g>
        </svg>
      ),
      name: "OEM/IAM Mapping",
      route: "oesoemmapping",
    },
    // {
    //   featureCode: "ANNEXURE_PART",
    //   icon: <AssignmentOutlinedIcon fontSize="inherit" />,
    //   name: "Annexure/Core Product List",
    //   route: "annexurePartList",
    // },
    {
      icon: <CardGiftcard fontSize="inherit" />,
      name: "Special Price Request",
      route: "specialpricekam",
    },
    {
      icon: <CreditCardIcon fontSize="inherit" />,
      name: "Credit Request",
      route: "creditlist",
    },
    {
      icon: <ListAltIcon fontSize="inherit" />,
      name: "Manage Stock",
      route: "managestock",
    },
    {
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "adminspecialoffers",
    },
    {
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  let KamAdminSideMenu = [
    {
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      icon: <PersonOutlineIcon fontSize="inherit" />,
      name: "Customers",
      route: "dealers",
    },

    {
      icon: <CardGiftcard fontSize="inherit" />,
      name: "Special Price Request",
      route: "specialpricekam",
    },
    {
      icon: <CreditCardIcon fontSize="inherit" />,
      name: "Credit Request",
      route: "creditlist",
    },
    {
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "adminspecialoffers",
    },
    {
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ]

  const FSESideMenuItems = [
    {
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      icon: <PersonOutlineIcon fontSize="inherit" />,
      name: "Customers",
      route: "dealers",
    },
    {
      featureCode: "ENQ_LIST",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Order Enquiry",
      route: "orderenquiry",
    },
    {
      featureCode: "ORD_LIST",
      icon: <LocalMallOutlinedIcon fontSize="inherit" />,
      name: "Order History",
      route: "orderhistory",
    },
    {
      featureCode: "product_team",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" className="icon-svg">
          <g id="checklist" transform="translate(-0.251)">
            <path id="Path_19" data-name="Path 19" d="M60.979,142.5a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -134.828)" />
            <path id="Path_20" data-name="Path 20" d="M170.368,182.345h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -175.562)" />
            <path id="Path_21" data-name="Path 21" d="M66.3,244.5H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -235.406)" />
            <path id="Path_22" data-name="Path 22" d="M60.979,314.275a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -300.186)" />
            <path id="Path_23" data-name="Path 23" d="M170.368,354.07h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -340.9)" />
            <path id="Path_24" data-name="Path 24" d="M66.3,415.337H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -399.758)" />
            <path id="Path_25" data-name="Path 25" d="M17.893,0H7.291A.973.973,0,0,0,6.95.067,1.833,1.833,0,0,0,6.605.034,1.814,1.814,0,0,0,4.888,1.261h-.6A.794.794,0,0,0,3.5,2H1.538A1.287,1.287,0,0,0,.251,3.286v14.43A1.287,1.287,0,0,0,1.538,19H11.672a1.289,1.289,0,0,0,1.242-.95h5.072a1.38,1.38,0,0,0,1.265-1.355V1.355A1.358,1.358,0,0,0,17.893,0ZM4.612,2.373H5.35a.556.556,0,0,0,.557-.545.7.7,0,0,1,1.4,0,.556.556,0,0,0,.557.545H8.6v.612H4.612Zm7.233,15.343a.173.173,0,0,1-.173.173H1.538a.173.173,0,0,1-.173-.173V3.286a.173.173,0,0,1,.173-.173H3.5v.118a.867.867,0,0,0,.867.865H8.845a.867.867,0,0,0,.867-.865V3.113h1.961a.173.173,0,0,1,.173.173Zm6.292-1.021a.243.243,0,0,1-.216.242l-.016,0H12.959V3.286A1.287,1.287,0,0,0,11.672,2H9.708a.8.8,0,0,0-.8-.74H8.322c-.017-.051-.038-.1-.059-.15h9.63a.245.245,0,0,1,.245.244Z" transform="translate(0)" />
          </g>
        </svg>
      ),
      name: "OEM/IAM Mapping",
      route: "oesoemmapping",
    },
    // {
    //   featureCode: "ARC_LIST",
    //   icon: <LocalMallOutlinedIcon fontSize="inherit" />,
    //   name: "Archived Data",
    //   route: "archiveddata",
    // // },
    // {
    //   featureCode: "ANNEXURE_PART",
    //   icon: <AssignmentOutlinedIcon fontSize="inherit" />,
    //   name: "Annexure Part List",
    //   route: "annexurePartList",
    // },
    {
      featureCode: "RETURN_REQUEST",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Review Return Request",
      route: "returnrequest",
    },
    {
      featureCode: "SALES_RETURN",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Sales Return",
      route: "returnorder",
    },
    {
      featureCode: "QUO_LIST",
      icon: <List fontSize="inherit" />,
      name: "Quotation",
      route: "quotation",
    },
    {
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "adminspecialoffers",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),
    {
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  const FSESideMenuItemsForDealer = [
    {
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      icon: <PersonOutlineIcon fontSize="inherit" />,
      name: "Customers",
      route: "dealers",
    },
    {
      featureCode: "ENQ_LIST",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Order Enquiry",
      route: "annexurecreateenquiry",
    },
    {
      featureCode: "ORD_LIST",
      icon: <LocalMallOutlinedIcon fontSize="inherit" />,
      name: "Order History",
      route: "orderhistory",
    },
    {
      featureCode: "product_team",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" className="icon-svg">
          <g id="checklist" transform="translate(-0.251)">
            <path id="Path_19" data-name="Path 19" d="M60.979,142.5a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -134.828)" />
            <path id="Path_20" data-name="Path 20" d="M170.368,182.345h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -175.562)" />
            <path id="Path_21" data-name="Path 21" d="M66.3,244.5H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -235.406)" />
            <path id="Path_22" data-name="Path 22" d="M60.979,314.275a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -300.186)" />
            <path id="Path_23" data-name="Path 23" d="M170.368,354.07h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -340.9)" />
            <path id="Path_24" data-name="Path 24" d="M66.3,415.337H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -399.758)" />
            <path id="Path_25" data-name="Path 25" d="M17.893,0H7.291A.973.973,0,0,0,6.95.067,1.833,1.833,0,0,0,6.605.034,1.814,1.814,0,0,0,4.888,1.261h-.6A.794.794,0,0,0,3.5,2H1.538A1.287,1.287,0,0,0,.251,3.286v14.43A1.287,1.287,0,0,0,1.538,19H11.672a1.289,1.289,0,0,0,1.242-.95h5.072a1.38,1.38,0,0,0,1.265-1.355V1.355A1.358,1.358,0,0,0,17.893,0ZM4.612,2.373H5.35a.556.556,0,0,0,.557-.545.7.7,0,0,1,1.4,0,.556.556,0,0,0,.557.545H8.6v.612H4.612Zm7.233,15.343a.173.173,0,0,1-.173.173H1.538a.173.173,0,0,1-.173-.173V3.286a.173.173,0,0,1,.173-.173H3.5v.118a.867.867,0,0,0,.867.865H8.845a.867.867,0,0,0,.867-.865V3.113h1.961a.173.173,0,0,1,.173.173Zm6.292-1.021a.243.243,0,0,1-.216.242l-.016,0H12.959V3.286A1.287,1.287,0,0,0,11.672,2H9.708a.8.8,0,0,0-.8-.74H8.322c-.017-.051-.038-.1-.059-.15h9.63a.245.245,0,0,1,.245.244Z" transform="translate(0)" />
          </g>
        </svg>
      ),
      name: "OEM/IAM Mapping",
      route: "oesoemmapping",
    },
    {
      featureCode: "RETURN_REQUEST",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Review Return Request",
      route: "returnrequest",
    },
    {
      featureCode: "SALES_RETURN",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Sales Return",
      route: "returnorder",
    },
    // {
    //   featureCode: "ARC_LIST",
    //   icon: <LocalMallOutlinedIcon fontSize="inherit" />,
    //   name: "Archived Data",
    //   route: "archiveddata",
    // },
    {
      featureCode: "ANNEXURE_PART",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Annexure/Core Product List",
      route: "annexurePartList",
    },
    {
      featureCode: "QUO_LIST",
      icon: <List fontSize="inherit" />,
      name: "Quotation",
      route: "quotation",
    },
    {
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "adminspecialoffers",
    },
    {
      featureCode: "WEM",
      icon: <BlurCircularIcon fontSize="inherit" />,
      name: "Workshop Equipment Materials",
      route: "workshopmaterials",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),

    {
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  const FSEWorkshopSideMenuItems = [
    {
      icon: <DashboardOutlinedIcon fontSize="inherit" />,
      name: "Dashboard",
      route: "dashboard",
    },
    {
      icon: <PersonOutlineIcon fontSize="inherit" />,
      name: "Customers",
      route: "dealers",
    },
    {
      featureCode: "product_team",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" className="icon-svg">
          <g id="checklist" transform="translate(-0.251)">
            <path id="Path_19" data-name="Path 19" d="M60.979,142.5a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -134.828)" />
            <path id="Path_20" data-name="Path 20" d="M170.368,182.345h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -175.562)" />
            <path id="Path_21" data-name="Path 21" d="M66.3,244.5H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -235.406)" />
            <path id="Path_22" data-name="Path 22" d="M60.979,314.275a.545.545,0,0,0,.753-.044l1.325-1.511a.529.529,0,0,0-.8-.7l-.971,1.107-.26-.235a.529.529,0,1,0-.71.784Z" transform="translate(-57.783 -300.186)" />
            <path id="Path_23" data-name="Path 23" d="M170.368,354.07h-3.052a.528.528,0,1,0,0,1.057h3.052a.528.528,0,1,0,0-1.057Z" transform="translate(-160.264 -340.9)" />
            <path id="Path_24" data-name="Path 24" d="M66.3,415.337H59.443a.528.528,0,1,0,0,1.057H66.3a.528.528,0,1,0,0-1.057Z" transform="translate(-56.595 -399.758)" />
            <path id="Path_25" data-name="Path 25" d="M17.893,0H7.291A.973.973,0,0,0,6.95.067,1.833,1.833,0,0,0,6.605.034,1.814,1.814,0,0,0,4.888,1.261h-.6A.794.794,0,0,0,3.5,2H1.538A1.287,1.287,0,0,0,.251,3.286v14.43A1.287,1.287,0,0,0,1.538,19H11.672a1.289,1.289,0,0,0,1.242-.95h5.072a1.38,1.38,0,0,0,1.265-1.355V1.355A1.358,1.358,0,0,0,17.893,0ZM4.612,2.373H5.35a.556.556,0,0,0,.557-.545.7.7,0,0,1,1.4,0,.556.556,0,0,0,.557.545H8.6v.612H4.612Zm7.233,15.343a.173.173,0,0,1-.173.173H1.538a.173.173,0,0,1-.173-.173V3.286a.173.173,0,0,1,.173-.173H3.5v.118a.867.867,0,0,0,.867.865H8.845a.867.867,0,0,0,.867-.865V3.113h1.961a.173.173,0,0,1,.173.173Zm6.292-1.021a.243.243,0,0,1-.216.242l-.016,0H12.959V3.286A1.287,1.287,0,0,0,11.672,2H9.708a.8.8,0,0,0-.8-.74H8.322c-.017-.051-.038-.1-.059-.15h9.63a.245.245,0,0,1,.245.244Z" transform="translate(0)" />
          </g>
        </svg>
      ),
      name: "OEM/IAM Mapping",
      route: "oesoemmapping",
    },
    {
      featureCode: "ENQ_LIST",
      icon: <AssignmentOutlinedIcon fontSize="inherit" />,
      name: "Order Enquiry",
      route: "orderenquiry",
    },
    {
      featureCode: "ORD_LIST",
      icon: <LocalMallOutlinedIcon fontSize="inherit" />,
      name: "Order History",
      route: "orderhistory",
    },
    {
      featureCode: "RETURN_REQUEST",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Review Return Request",
      route: "returnrequest",
    },
    {
      featureCode: "SALES_RETURN",
      icon: <RefreshIcon fontSize="inherit" />,
      name: "Sales Return",
      route: "returnorder",
    },
    // {
    //   featureCode: "ARC_LIST",
    //   icon: <LocalMallOutlinedIcon fontSize="inherit" />,
    //   name: "Archived Data",
    //   route: "archiveddata",
    // },
    // {
    //   featureCode: "CAT-LOG",
    //   icon: <img src="./catalogue.svg" style={{ fill: "#757575", height: "1.3rem", width: "1.3rem", opacity: "0.5" }} />,
    //   name: "Catalogue",
    //   route: "#",
    // },
    {
      featureCode: "QUO_LIST",
      icon: <List fontSize="inherit" />,
      name: "Quotation",
      route: "quotation",
    },
    {
      icon: <LocalOfferIcon fontSize="inherit" />,
      name: "Special Offers",
      route: "adminspecialoffers",
    },
    {
      featureCode: "WEM",
      icon: <BlurCircularIcon fontSize="inherit" />,
      name: "Workshop Equipment Materials",
      route: "workshopmaterials",
    },
    ...(canDownloadInvoice
      ? [{
        featureCode: "DOWNLOAD_INVOICE",
        icon: <GetAppIcon fontSize="inherit" />,
        name: "Search Invoice",
        route: "searchinvoice",
      }]
      : []),

    {
      icon: <PersonIcon fontSize="inherit" />,
      name: "My Profile",
      route: "adminprofile",
    },
    {
      icon: <ExitToAppIcon fontSize="inherit" />,
      name: "Logout",
    },
  ];

  const callLogout = async () => {
    await dispatch(logoutUser());
    await dispatch(logout());
    signOut(userDispatch);
    instance.logoutRedirect({ postLogoutRedirectUri: "/" });
  }

  const loadProfileDetails = useCallback(() => {
    const b2cUid = sessionStorage.getItem('userId');
    const userType = sessionStorage.getItem('userType');

    if (b2cUid !== "undefined" && b2cUid !== null && userType !== 'undefined' && userType !== null) {
      dispatch(getProfile(b2cUid, userType));
    }
  }, [dispatch]);

  useEffect(() => {
    history.listen(() => {
      setCurrentUrl(window.location.href);
      if (window.location.href.includes('/oescatalogue')) {
        dispatch(openSideMenu(false));
      } else { dispatch(openSideMenu(true)); }
    })
  }, [history]);

  useEffect(() => {
    if (!profileDetails)
      loadProfileDetails();
    //  let data: any = profileservice.profileStatus(sapCustomerId)
    // setGetAccInfodata(data);
  }, [profileDetails, loadProfileDetails]);

  const getCount = async (sapCustomerId: any) => {
    let count: any = await dispatch(getExpiredDocCount(sapCustomerId));
    if (count && count.data) {
      setCount(count?.data?.count);
    }
  }
  const { announcements }: any = useSelector((state: any) => state.announcements);

  useEffect(() => {
    if (!announcements)
      dispatch(getAnnouncements());
  }, [announcements, dispatch]);

  const documentExpiryData = async () => {
    let expiryStatusData: any
    expiryStatusData = await dispatch(getDocumentExpiryStatus(sapCustomerId, true));
    if (expiryStatusData) {
      setDocumentExpiryStatusData(expiryStatusData);

      if (sessionStorage.getItem('userType-Profile-API') === 'Admin' && blockIntent !== false && customerCurrentStatus !== "Deactive") {
        if (sessionStorage.getItem('userType-Profile-API') === 'Admin' && expiryStatusData && expiryStatusData.data && expiryStatusData.data.messages && expiryStatusData.data.messages.length > 0) {
          setshowDeactivateDialog(true);
        }
      } else if (sessionStorage.getItem('userType-Profile-API') === 'Admin' && blockIntent === true && customerCurrentStatus === "Deactive" && expiryStatusData && expiryStatusData.data && expiryStatusData.data.messages && expiryStatusData.data.messages.length > 0) {
        setshowDeactivateDialog(true);
      }
    }
  }

  const getBackoutNotification = async () => {
    let backoutData: any = await dispatch(getBlackoutNotificationData());
    if (backoutData?.message?.status == "S" && backoutData?.data?.[0]) {
      setShowBlackoutPopUp(true);
      setBlackoutPopUpData(backoutData.data[0]);
    }
  }

  useEffect(() => {
    const isOnboardingPage = window.location.href.includes('/onboarding');

    if (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo.userType !== 'guestAdmin') {
      documentExpiryData();
    }

    // Skip blackout/announcement popup while on the onboarding page
    if (!isOnboardingPage) {
      getBackoutNotification();
    }

    sessionStorage.setItem('customerId-Profile-API', profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.sapCustomerId);
    sessionStorage.setItem('webApplicationLoginId-Profile-API', profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.webApplicationLoginId);
    sessionStorage.setItem('userType-Profile-API', profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType);

    const data = {
      userType: "DEALER",
      sapCustomerId: sapCustomerId,
      webApplicationLoginId: sessionStorage.getItem('webApplicationLoginId-Profile-API')
    }
    if (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType === 'Admin') {
      dispatch(addNotifications(data));
    }

    dispatch(getTermsAndConditions());
    if (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType === 'Admin') {
      setTimeout(() => {
        dispatch(getAllNotifications(sessionStorage.getItem('customerId-Profile-API'), "Admin"));
      }, 1000)
      getCount(sapCustomerId);

      let data: any = profileservice.profileStatus(sapCustomerId)
      if (data.data && !data.data.isActive || profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.deactivationReason && profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.isActive === false) {
        setOpenDeactivatedDialog(profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.deactivationReason)
      }
      if (data.data && data.data.tradepointAccessToCustomer === false || profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.tradepointAccessToCustomer === false) {
        setOpenTradepointAccessDialog("Please contact Al-Futtaim Sales Support for more information.")
      }
    } else if (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType === 'User') {
      dispatch(getAllNotifications(sessionStorage.getItem('webApplicationLoginId-Profile-API'), "user"));
      getCount(sapCustomerId);
      let data: any = profileservice.profileStatus(sapCustomerId)
      if (data.data && !data.data.isActive || profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.deactivationReason && profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.isActive === false) {
        setOpenDeactivatedDialog(profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.deactivationReason)
      }
      if (data.data && data.data.tradepointAccessToCustomer === false || profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.tradepointAccessToCustomer === false) {
        setOpenTradepointAccessDialog("Please contact Al-Futtaim Sales Support for more information.")
      }
    } else if (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType === 'guestAdmin') {
      dispatch(getAllOnbardingNotifications(profileDetails.data.data.basicInfo.b2bUserId, "guestAdmin"));
    } else if (userType === 'SRE' || sessionStorage.getItem('userType-Profile-API') === "SRE") {
      dispatch(getAllNotifications(sessionStorage.getItem('webApplicationLoginId-Profile-API'), "sre"));
    } else if (userType === 'kam' || sessionStorage.getItem('userType-Profile-API') === "KAM") {
      dispatch(getAllNotifications(sessionStorage.getItem('webApplicationLoginId-Profile-API'), "kam"));
      dispatch(getDocumentAccessKamList(sessionStorage.getItem('webApplicationLoginId-Profile-API')));
    } else if (userType && userType.toLowerCase() === 'fse' || sessionStorage.getItem('userType-Profile-API') === "FSE") {
      dispatch(getAllNotifications(sessionStorage.getItem('webApplicationLoginId-Profile-API'), "fse"));
    } else if (userType === 'creditTeam' || sessionStorage.getItem('userType-Profile-API') === "CREDIT_CONTROL_MANAGER") {
      dispatch(getAllNotifications(sessionStorage.getItem('webApplicationLoginId-Profile-API'), "creditTeam"));
    } else if (userType === "pricing_team" || sessionStorage.getItem('userType-Profile-API') === "PRICING_TEAM") {
      dispatch(getAllNotifications(sessionStorage.getItem('webApplicationLoginId-Profile-API'), "pricing_team"));
    } else if (userType === "product_team" || sessionStorage.getItem('userType-Profile-API') === "PRODUCT_TEAM") {
      dispatch(getAllNotifications(sessionStorage.getItem('webApplicationLoginId-Profile-API'), "PRODUCT_TEAM"));
    }
  }, []);
  let dealerCountry;
  let dealerLogo;
  let customerType: any;
  let companyName;
  let userName;
  let userType: any;
  let customerTypeAccess: any;
  let region;
  let isKamOnboarded: any;
  let percentageForSellingPrice: any;
  let markupPercentage: any;
  let featureAccessibility: any;
  let customerTierType: any;
  let uType = sessionStorage.getItem('userType');

  // dealerCountry = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.addresses && profileDetails.data.data.customerInfo.addresses.length > 0 && profileDetails.data.data.customerInfo.addresses.split(',')[0]) || "";
  dealerLogo = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.logo) || "";
  customerType = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.customerType) || "";
  companyName = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.companyName) || "";
  userName = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo.firstName + " " + profileDetails.data.data.basicInfo.lastName) || "";
  region = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo.region) || '';
  userType = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo.userType) || "";
  isKamOnboarded = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo.isAddedByKam) || false;
  percentageForSellingPrice = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.percentageForSellingPriceApply) || false;
  markupPercentage = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.markupPercentage) || false;
  customerTierType = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.customerTierType);
  featureAccessibility = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.accessParameter && profileDetails.data.data.accessParameter.featureAccessibility);

  if (sessionStorage.getItem('userType') === 'FSE' || userType === "FSE") {
    let filteredTypes: any = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo.customerTypeAccess && profileDetails.data.data.basicInfo.customerTypeAccess.length > 0 && profileDetails.data.data.basicInfo.customerTypeAccess.filter((type: any) => type.toLowerCase() !== "all");

    let formattedTypes = filteredTypes && filteredTypes.length > 0 && filteredTypes.map((type: any) => {
      if (type.toLowerCase() === "intbusiness") {
        return "Int. Business";
      } return type.replace(/\b\w/g, (char: string) => char.toUpperCase());
    });

    customerTypeAccess = formattedTypes && formattedTypes.join(', ');

    if (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo.customerTypeAccess && profileDetails.data.data.basicInfo.customerTypeAccess.length > 0 && profileDetails.data.data.basicInfo.customerTypeAccess && profileDetails.data.data.basicInfo.customerTypeAccess.includes("workshop")) {
      customerTierType = 'Workshop'
    }
  }

  let customerTypeAccessKAM: any = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo.customerTypeAccess;
  useEffect(() => {
    if (currentUrl) {
      if ((((currentUrl.includes('onboarding')) || (currentUrl.includes('profile') && menuItems && menuItems.length === 3)) && !isKamOnboarded)) {
        setMenuItems(onBoardMenuItems);
      } else if (((currentUrl.includes('onboarding')) || (currentUrl.includes('profile') && menuItems && menuItems.length === 3)) && isKamOnboarded) {
        setMenuItems(onBoardMenuItemsForUserConfirmation);
      } else if ((currentUrl.includes('creditteam')) || (currentUrl.includes('creditteamdetails')) || (currentUrl.includes('profile') && adminMenuItems && adminMenuItems.length === 3 && sessionStorage.getItem('userType') === 'creditTeam')) {
        setAdminMenuItems(creditRequestMenuItems);
      } else if (sessionStorage.getItem('userType') === 'FSE' && sessionStorage.getItem('userType') !== 'sre' && !customerTypeAccess.includes("TBL Dealer") && (customerTierType === 'Workshop' || customerTierType === 'tpcdealer' || customerTierType === 'TBL Dealer')) {
        setAdminMenuItems(FSEWorkshopSideMenuItems);
      } else if ((sessionStorage.getItem('userType')?.toLowerCase() === 'kam' || userType?.toLowerCase() === 'kam') && customerTypeAccessKAM.includes("dealer") && customerTypeAccessKAM.includes("TBL Dealer")) {
        setAdminMenuItems(adminSideMenuItemsKAM);
      } else if ((sessionStorage.getItem('userType')?.toLowerCase() === 'kam' || userType?.toLowerCase() === 'kam') && customerTypeAccessKAM.includes("dealer") && !customerTypeAccessKAM.includes("TBL Dealer")) {
        // If customerTypeAccessKAM includes "dealer" for KAM user, always set dealer menu
        setAdminMenuItems(adminSideMenuItemsDealerKam);
      } else if ((sessionStorage.getItem('userType')?.toLowerCase() === 'kam' || userType?.toLowerCase() === 'kam') && customerTypeAccessKAM.includes("TBL Dealer") && !customerTypeAccessKAM.includes("dealer")) {
        // KAM user with TBL Dealer access
        setAdminMenuItems(adminSideMenuItemsTBLKAM);
      } else if ((sessionStorage.getItem('userType')?.toLowerCase() === 'kam' || userType?.toLowerCase() === 'kam')) {
        // KAM user without dealer or TBL Dealer access
        setAdminMenuItems(adminSideMenuItems);
      } else if (sessionStorage.getItem('userType') === 'FSE' && !(
        customerTypeAccess.includes('Dealer') ||
        customerTierType === 'Dealer' ||
        customerTierType === 'Workshop' ||
        customerTierType === 'tpcdealer' ||
        customerTierType === 'TBL Dealer'
      )) {
        setAdminMenuItems(FSESideMenuItems);
      } else if (
        sessionStorage.getItem('userType') === 'FSE' &&
        (customerTierType === 'Dealer' || customerTypeAccess.includes('Dealer'))
        && !customerTypeAccess.includes('TBL Dealer') && !customerTypeAccess.includes('Government')
        && !customerTypeAccess.includes('Fleet') && !customerTypeAccess.includes('Int. Business') &&
        !(
          customerTierType === 'Workshop' ||
          customerTierType === 'tpcdealer' ||
          customerTierType === 'TBL Dealer'
        )
      ) {
        setAdminMenuItems(FSESideMenuItemsForDealer);
      } else if (userType !== "AFG_SUPER_ADMIN" && sessionStorage.getItem('userType') !== 'sre' &&
        // } else if (sessionStorage.getItem('userType')?.toLowerCase() === 'kam' && sessionStorage.getItem('userType') !== 'sre' && !customerTypeAccessKAM.includes("TBL Dealer")) {
        //   setAdminMenuItems(adminSideMenuItems);
        // } else if (sessionStorage.getItem('userType')?.toLowerCase() === 'kam' && sessionStorage.getItem('userType') !== 'sre' && customerTypeAccessKAM.includes("TBL Dealer")) {
        //   setAdminMenuItems(adminSideMenuItemsKAM);
        // } else if (sessionStorage.getItem('userType') === 'FSE' && sessionStorage.getItem('userType') !== 'sre' && !customerTypeAccess.includes("TBL Dealer") && !customerTypeAccess.includes('Int. Business') && !customerTypeAccess.includes('Government') && !customerTypeAccess.includes("Fleet") && (customerTierType !== 'Workshop' && customerTierType !== 'tpcdealer' || customerTierType !== 'TBL Dealer')) {
        //   setAdminMenuItems(FSESideMenuItems);
        // } else if (userType !== "AFG_SUPER_ADMIN" && sessionStorage.getItem('userType') !== 'sre' &&
        (
          currentUrl.includes('specialpricerequest') ||
          currentUrl.includes('myschedule') ||
          (currentUrl.includes("/viewspecialprice") && currentUrl.includes("/viewspecialpricekam") && userType !== "KAM") ||
          (currentUrl.includes('/adminprofile') && adminMenuItems && adminMenuItems.length === 5 && sessionStorage.getItem('userType') !== 'FSE' && userType.toLowerCase() !== 'sre')
        )
      ) {
        setAdminMenuItems(specialPriceRequest);
      } else if (userType === "AFG_SUPER_ADMIN" && (currentUrl.includes('planfeatures')) || (currentUrl.includes('settarget')) || (currentUrl.includes('superadmindealers')) || (currentUrl.includes('profile') && adminMenuItems && adminMenuItems.length === 5 && sessionStorage.getItem('userType') !== 'FSE') && sessionStorage.getItem('userType') !== 'sre') {
        setAdminMenuItems(superAdminMenuItems);
      } else if (userType.toLowerCase() === "sre" && sessionStorage.getItem('userType') !== 'FSE') {
        setAdminMenuItems(SREMenuItems);
      } else if ((currentUrl.includes('/oesoemmapping') && sessionStorage.getItem('userType') !== 'FSE') || (currentUrl.includes('/adminprofile') && adminMenuItems && adminMenuItems.length === 3 && sessionStorage.getItem('userType')?.toLowerCase() === 'product_team' && sessionStorage.getItem('userType') !== 'creditTeam' && userType?.toLowerCase() !== "kam" && sessionStorage.getItem('userType') !== 'sre')) {
        setAdminMenuItems(ProductTeamSideMenuItems);
      } else if (((customerTierType === 'Dealer' && (isAnnexurePartAccess === false || isAnnexurePartAccess === "")) || !customerTierType)
        && sessionStorage.getItem('userType') !== 'FSE' && sessionStorage.getItem('userType') !== 'sre'
        && userType !== "guestAdmin") {
        setMenuItems(dealerSideMenuItems);
      } else if (((customerTierType === 'Dealer' && isAnnexurePartAccess === true) || !customerTierType)
        && sessionStorage.getItem('userType') !== 'FSE' && sessionStorage.getItem('userType') !== 'sre'
        && userType !== "guestAdmin") {
        setMenuItems(dealerAnnexureSideMenuItems);
      } else if ((customerTierType === 'Workshop' || customerTierType === 'tpcdealer') && (customerTierType !== "Int. Business" && customerTierType !== 'Government' && customerTierType !== "Fleet" && customerTierType !== 'TBL Dealer') && sessionStorage.getItem('userType') !== 'FSE' && userType !== "guestAdmin") {
        setMenuItems(workshopSideMenuItems);
      } else if (customerTierType === 'TBL Dealer' && userType !== "guestAdmin" && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
        setMenuItems(tblDealerPartsSideMenuItems);
      } else if (customerTierType === 'TBL Dealer' && userType !== "guestAdmin" && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Tyres") && !tblDealerAccess.includes("Parts")) {
        setMenuItems(tblDealerTyresSideMenuItems);
      } else if (customerTierType === 'TBL Dealer' && userType !== "guestAdmin" && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
        setMenuItems(tblDealerPartsSideMenuItems);
      } else if (customerTierType === 'Government' && sessionStorage.getItem('userType') !== 'FSE' && userType !== "guestAdmin") {
        setMenuItems(sideMenuItems)
      } else if (customerTierType === "Fleet" && sessionStorage.getItem('userType') !== 'FSE' && userType !== "guestAdmin") {
        setMenuItems(sideMenuItems)
      } else if (customerTierType === "Int. Business" && sessionStorage.getItem('userType') !== 'FSE' && userType !== "guestAdmin") {
        const hasSalesReturnAccess = shouldShowSalesReturn();
        const filteredIbMenu = hasSalesReturnAccess
          ? ibSideMenuItems
          : ibSideMenuItems.filter((item: any) => item.featureCode !== 'SALES_RETURN');
        setMenuItems(filteredIbMenu);
        console.log('IB SALES_RETURN debug', {
          hasSalesReturnAccess: shouldShowSalesReturn(),
          ibSideMenuItemsHasSalesReturn: ibSideMenuItems.some((i: any) => i.featureCode === 'SALES_RETURN'),
        });
      } else if (customerTierType === "tpcdealer" && sessionStorage.getItem('userType') !== 'FSE' && userType !== "guestAdmin") {
        setMenuItems(sideMenuItems)
      } else if (customerTierType === "TBL Dealer" && sessionStorage.getItem('userType') !== 'FSE' && userType !== "guestAdmin") {
        setMenuItems(sideMenuItems)
      } else if (sessionStorage.getItem('userType') === 'FSE' && customerTypeAccess.includes("TBL Dealer")) {
        setAdminMenuItems(sideMenuItemsForTBLFSE)
      }
    }
  }, [currentUrl, userType, customerTierType]);

  useEffect(() => {
    if (customerTierType === 'Workshop' || customerTierType === "Fleet" || customerTierType === "Government") {
      isShowAchievements(false)
    } else {
      if (isAccessAchievement && isAccessAchievement.data && isAccessAchievement.data.accessToViewAchievementModule && (isAccessAchievement.data.customerType?.toLowerCase() === 'dealer' || isAccessAchievement.data.customerType === 'tpcdealer')) {
        isShowAchievements(true)
      } else {
        isShowAchievements(false);
      }
      if (isAccessAchievement && isAccessAchievement.data && isAccessAchievement.data?.customerAccountTier && (isAccessAchievement?.data?.customerType?.toLowerCase() === 'dealer' || isAccessAchievement?.data?.customerType === 'tpcdealer')) {
        sessionStorage.setItem('currentTier', isAccessAchievement?.data?.customerAccountTier)
      }
    }

    if (customerTierType === "Fleet" || customerTierType === "Government" || sessionStorage.getItem('userType') === 'FSE') {
      setShowQuotation(true);
    } else {
      setShowQuotation(false);
    }
  }, [isAccessAchievement, customerTierType]);

  useEffect(() => {
    if (featureAccessibility && featureAccessibility.length > 0) {
      isDisplaySellingPrice(featureAccessibility);
    }
  }, [featureAccessibility]);

  useEffect(() => {
    setAssignedKAMs(get(profileDetails, 'data.data.basicInfo.assignedKamAndFse', []));
    dispatch(getAllBrands('all'));
    dispatch(getAccessControlOfBrands());
  }, [profileDetails]);

  // const getPublishAgreementDocs = () => {
  //   let data: any = dispatch(getAgreementDocs('Dealer', limit, skip));


  //   // add conditions here
  // }


  const getPublishAgreementDocs = async () => {
    const limit = 20; // Define limit
    let skip = 0; // Initialize skip
    let totalCount = 0; // Initialize totalCount

    let tempData: any = {
      Silver: [],
      Gold: [],
      Platinum: [],
      Elite: [],
      otherDealers: [],
    }; // Initialize a temporary object to accumulate all data before updating the state

    do {
      const response: any = await dispatch(getAgreementDocs('Dealer', limit, skip));

      if (response && response.data) {
        const res = response.data;
        // Check if any category has data
        const isDataFetched =
          res.Silver?.length > 0 ||
          res.Gold?.length > 0 ||
          res.Platinum?.length > 0 ||
          res.Elite?.length > 0 ||
          res.otherDealers?.length > 0;

        if (isDataFetched) {
          // Append the fetched data to the corresponding categories in tempData
          Object.keys(res).forEach((key) => {
            if (Array.isArray(res[key])) {
              tempData[key] = [
                ...tempData[key],      // Append existing data
                ...res[key],           // Append new fetched data
              ];
            }
          });
        }
      }

      // Update totalCount from the first response (for pagination)
      if (response && response.data && response.data.customersTotaCount && skip === 0) {
        totalCount = response.data.customersTotaCount;
      }

      // Increment skip by the limit to fetch the next set of data
      skip += limit;

    } while (skip < totalCount); // Continue looping until all data is fetched

    // Once all data is fetched, update the state with the accumulated data
    dispatch(setAgreementDetails(tempData));
  };

  useEffect(() => {
    const isSalesReturnAccess =
      profileDetails?.data?.data?.customerInfo?.isSalesReturnAccess;
    // If access is explicitly false → remove Sales Return
    if (isSalesReturnAccess === false) {
      setMenuItems((prevItems: any[]) => {
        if (!prevItems?.length) return prevItems;
        return prevItems.filter(
          (item: any) => item.featureCode !== 'SALES_RETURN'
        );
      });
      setAdminMenuItems((prevItems: any[]) => {
        if (!prevItems?.length) return prevItems;
        return prevItems.filter(
          (item: any) => item.featureCode !== 'SALES_RETURN'
        );
      });
    }
  }, [profileDetails, currentUrl]);


  useEffect(() => {
    if (isAdmin) {
      // Determine which menu to use
      let selectedMenu: any[] = [];

      if (userType === "CREDIT_CONTROL_MANAGER") {
        selectedMenu = [...creditRequestMenuItems];
      } else if (userType === "AFG_SUPER_ADMIN") {
        selectedMenu = [...superAdminMenuItems];
        getPublishAgreementDocs();
      } else if (userType === "PRICING_TEAM") {
        selectedMenu = [...specialPriceRequest];
      } else if (userType?.toLowerCase() === "product_team") {
        selectedMenu = [...ProductTeamSideMenuItems];
      } else if (userType?.toLowerCase() === "sre" || sessionStorage.getItem('userType')?.toLowerCase() === 'sre') {
        selectedMenu = [...SREMenuItems];
      } else if (sessionStorage.getItem('userType')?.toLowerCase() === 'fse' || userType?.toLowerCase() === "fse") {
        const customerTypeArray = customerTypeAccess?.split(',').map((type: any) => type.trim()) || [];
        const isDealer = customerTypeArray.includes('Dealer') || customerTierType === 'Dealer';

        if (isDealer) {
          setAdminMenuItems(FSESideMenuItemsForDealer);
          selectedMenu = [...FSESideMenuItemsForDealer];
        } else if (
          customerTypeAccess.includes('Int. Business') ||
          customerTypeAccess.includes('Government') ||
          customerTypeAccess.includes("Fleet") ||
          customerTypeAccess.includes('TBL Dealer')
        ) {
          let FSEMenu = [...FSESideMenuItems];

          FSEMenu = FSEMenu.map((item) => {
            if (item.featureCode === "ENQ_LIST") {
              return { ...item, route: "orderenquiry" };
            }
            return item;
          });

          FSEMenu = FSEMenu.filter(item => item.featureCode !== "ANNEXURE_PART");

          // For IB-only FSE: RETURN_REQUEST & SALES_RETURN only applicable for Arch Auto (org 2428)
          const isIBOnlyFSE = customerTypeAccess.includes('Int. Business') &&
            !customerTypeAccess.includes('Government') &&
            !customerTypeAccess.includes('Fleet') &&
            !customerTypeAccess.includes('TBL Dealer');

          selectedMenu = FSEMenu;
        } else {
          selectedMenu = customerTierType === 'Workshop' && !customerTypeAccess?.includes("TBL Dealer")
            ? [...FSEWorkshopSideMenuItems]
            : customerTypeAccess?.includes("TBL Dealer")
              ? [...sideMenuItemsForTBLFSE]
              : [...FSESideMenuItems];

          // Remove Annexure/Core Product List if not a dealer
          selectedMenu = selectedMenu.filter((item: any) => item.featureCode !== "ANNEXURE_PART");
        }
      } else {
        if ((sessionStorage.getItem('userType')?.toLowerCase() === 'kam' || userType?.toLowerCase() === 'kam') && customerTypeAccessKAM.includes("TBL Dealer") && customerTypeAccessKAM.includes("dealer")) {
          selectedMenu = [...adminSideMenuItemsKAM];
          setAdminMenuItems(adminSideMenuItemsKAM);
        } else if ((sessionStorage.getItem('userType')?.toLowerCase() === 'kam' || userType?.toLowerCase() === 'kam') && customerTypeAccessKAM.includes("TBL Dealer") && !customerTypeAccessKAM.includes("dealer")) {
          selectedMenu = [...adminSideMenuItemsTBLKAM];
          setAdminMenuItems(adminSideMenuItemsTBLKAM);
        } else if ((sessionStorage.getItem('userType')?.toLowerCase() === 'kam' || userType?.toLowerCase() === 'kam') && customerTypeAccessKAM.includes("dealer")) {
          // If customerTypeAccessKAM includes "dealer" for KAM user, always set dealer menu
          selectedMenu = [...adminSideMenuItemsDealerKam];
          setAdminMenuItems(adminSideMenuItemsDealerKam);
        } else if (!customerTypeAccessKAM.includes("TBL Dealer")) {
          selectedMenu = [...adminSideMenuItems];
          setAdminMenuItems(adminSideMenuItems)
        }
      }

      const isFSEUserForFilter = sessionStorage.getItem('userType')?.toLowerCase() === 'fse' || userType?.toLowerCase() === 'fse';

      if (!isFSEUserForFilter) {
        const hasSalesReturnAccess = shouldShowSalesReturn();
        if (!hasSalesReturnAccess && sessionStorage.getItem('userType')?.toLowerCase() !== 'sre') {
          selectedMenu = selectedMenu.filter((item: any) => item.featureCode !== 'SALES_RETURN');
        }

        if ((customerTypeAccess && customerTypeAccess.includes('Int. Business'))) {
          const salesOrg = profileDetails?.data?.data?.basicInfo?.salesOrganization;
          const isArchAuto = Array.isArray(salesOrg) && salesOrg.some((so: any) => so?.salesOrganization === '2428' && so?.make === 'ARCH_AUTO');

          if (!isArchAuto) {
            selectedMenu = selectedMenu.filter((item: any) =>
              item.featureCode !== 'RETURN_REQUEST' && item.featureCode !== 'SALES_RETURN'
            );
          }
        }
      }

      setAdminMenuItems(selectedMenu);
    }
  }, [userType, isAdmin, customerTypeAccess, customerTierType, profileDetails, shouldShowSalesReturn, customerTypeAccessKAM]);
  // No adminMenuItems in dependencies

  const handleopenClose = (open?: any) => {
    setOpenLogoutDialog(open ? true : false);
  };

  const handleOpenCloseTAndC = (open?: any) => {
    setOpenTAndCDialog(open ? true : false);
  };

  useEffect(() => {
    if (isReadTandC === false && userType === 'Admin') {
      setOpenTAndCDialog(true);
    }
  }, [])

  const handleopenCloseSnackbar = (open?: any) => {
    setOpenSnackbar(open ? true : false);
  };

  const handleopenCloseErrorSnackbar = (open?: any) => {
    setOpenErrorSnackbar(open ? true : false);
  };

  const isDisplaySellingPrice = (accessParam: any) => {
    if (accessParam && accessParam.length > 0) {
      let data = accessParam.filter((param: any) => param.featureCode === 'DISPLAY_SELLING_PRICE');
      if (data && data.length > 0 && data[0].value === true) {
        dispatch(isSellingPrice(false))
      }
      setDisplayPrice(data);
    }
  }

  const isAccessToQuotation = () => {
    if ((customerTierType && customerTierType.toLowerCase() === "fleet") || (customerTierType && customerTierType.toLowerCase() === "government") || (sessionStorage.getItem('userType') == 'FSE')) {
      return true
    } else {
      return false
    }
  }

  const openCloseChooseCustomer = () => {
    setOpenChooseCustomerDialog(false);
  }

  const handleChooseCustomer = () => {
    setOpenChooseCustomerDialog(true);
    setIsChooseCustomerOpen(true);
  }


  const openCloseChooseCustomerIWSFSEDialog = () => {
    setIwsFseOpenChooseCustomerDialog(false);
  }

  const handleChooseCustomerIWSFSEDialog = () => {
    setIwsFseOpenChooseCustomerDialog(true);
  }

  const handleLoader = (data: any) => {
    setLoading(data);
  }

  const ENQ_LIST = !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.ENQ_LIST);
  return (
    <Fragment>
      {loading && <FullscreenLoader />}
      {(menuItems && menuItems.length === 0) && (adminMenuItems && adminMenuItems.length === 0) && <FullscreenLoader />}
      {
        <div className={leftMenuVisibility ? "leftMenuGlobal" : "collasped-menu"}>
          <Drawer
            variant={leftMenuVisibility ? "persistent" : "temporary"}
            anchor={"left"}
            open={leftMenuVisibility}
          >
            <div className="px-2 my-3 align-items-center">
              <IconButton
                onClick={() => {
                  dispatch(openSideMenu(false));
                }}
              >
                <MenuIcon />
              </IconButton>
              <img src={logoicon} onClick={() => {
                let userRole: any = _.get(profileDetails, "data.data.basicInfo.userType", '')
                if (userRole && userRole.toLowerCase() == "guestadmin") {
                  history.push('/onboarding')
                } else if (userRole === "CREDIT_CONTROL_MANAGER") {
                  history.push('/creditteam')
                } else if (userRole === "AFG_SUPER_ADMIN") {
                  history.push('/planfeatures')
                } else if (userRole === "PRODUCT_TEAM") {
                  history.push('/oesoemmapping')
                } else if (userRole === "PRICING_TEAM") {
                  history.push("/specialpricerequest")
                }
                else {
                  history.push('/dashboard')
                }
              }} alt="Logo" className="h-40 ml-2 " style={{ cursor: 'pointer' }} />
            </div>
            <div className="media bg-primary p-4">
              <img className="rounded-circle hw-45 ml-2" src={(userType === userTypes.kam || userType === userTypes.fse || userType === "product_team") ? tempKamLogo : dealerLogo ? dealerLogo : userType === "PRODUCT_TEAM" ? ProductTeamNoImage : NoImage} alt="Logo" />
              <div className="media-body">
                {userType === userTypes.kam || userType === userTypes.fse || userType === "AFG_SUPER_ADMIN" || userType === "product_team" ?
                  <>
                    <p className="clientNameSidebar d-flex align-items-center ml-1">
                      &nbsp;{userName}
                    </p>
                    <p className="clientNameSidebar d-flex align-items-center ml-1">
                      {Array.isArray(region) ? (
                        <>
                          &nbsp;{region && Array.isArray(region) && region.length === 0 ? '' :
                            region && Array.isArray(region) && region.length > 0 && region.map((value: any) => value).join(", ")
                          }
                        </>
                      ) : (
                        <>
                          {region && typeof region === 'string' ? region : ''}
                        </>)}
                    </p>
                    <p className="companyLocationSidebar ml-2 mb-1">
                      {userType === "AFG_SUPER_ADMIN" ? 'Super Admin' : userType === 'FSE' ?
                        `FSE / Sales advisor (${customerTypeAccess.includes("Workshop") && customerTypeAccess.includes("Tpcdealer") ? "TPC" : customerTypeAccess}) ` : userType}</p> </>
                  :
                  <>
                    <p className="companyNameSidebar ml-1 pl-1 mb-1">{companyName}</p>
                    <p className="companyLocationSidebar ml-2 mb-1">{userType === 'CREDIT_CONTROL_MANAGER' ? 'Credit Control Manager' : userType === "AFG_SUPER_ADMIN" ? 'Super Admin' : userType} {dealerCountry}</p> <p className="clientNameSidebar d-flex align-items-center ml-1">
                      <PersonOutlineIcon fontSize="inherit" />
                      &nbsp;{userName}
                    </p>
                    {/* <p className="companyLocationSidebar ml-2 mb-1">{userType === 'SUPER_ADMIN' ? 'Super Admin' : userType} {dealerCountry}</p> <p className="clientNameSidebar d-flex align-items-center ml-1">
                    <PersonOutlineIcon fontSize="inherit" />
                    &nbsp;{userName}
                    </p> */}
                  </>
                }
              </div>
            </div>
            <Dialog
              open={openDeactivatedDialog ? true : false}
              onClose={() => {
                setOpenDeactivatedDialog('')
                callLogout()
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth={true}>
              <Snackbar
                open={openSnackbar}
                handleopenClose={() => {
                  handleopenCloseSnackbar(false)
                }} text={successMessage} />
              <Snackbar
                open={openErrorSnackbar}
                type="error"
                handleopenClose={() => {
                  handleopenCloseErrorSnackbar(false)
                }} text={errorMessage} />
              <DialogContent>
                <div className={classes.icon}>
                  <WarningIcon className="delete-warning" fontSize="small" />
                </div>
                <div>
                  <DialogContentText id="alert-dialog-description">
                    <div className="mt-2">
                      <h5 className="submit-dialog-content">Your account has been deactivated</h5>
                      <p className="mt-3 dealer-table-subcontent-reason dealer-table-content text-red">Reason: {openDeactivatedDialog}</p>
                    </div>
                  </DialogContentText>
                </div>
              </DialogContent>
              <DialogActions className="mt-3 mb-3 justify-content-end">
                <Button variant="contained"
                  color="secondary" className={`createFavourite ${classes.createButton}`}
                  onClick={() => {
                    setOpenDeactivatedDialog('')
                    callLogout()
                  }}>Logout
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={openTradepointAccessDialog ? true : false}
              onClose={() => {
                setOpenTradepointAccessDialog('')
                callLogout()
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth={true}>

              <DialogContent>
                <div className={classes.icon}>
                  <WarningIcon className="delete-warning" fontSize="small" />
                </div>
                <div>
                  <DialogContentText id="alert-dialog-description">
                    <div className="mt-2">
                      <h5 className="submit-dialog-content">We are sorry that you no longer have access to the portal.</h5>
                      <p>{openTradepointAccessDialog}</p>
                    </div>
                  </DialogContentText>
                </div>
              </DialogContent>
              <DialogActions className="mt-3 mb-3 justify-content-end">
                <Button variant="contained"
                  color="secondary" className={`createFavourite ${classes.createButton}`}
                  onClick={() => {
                    setOpenTradepointAccessDialog('')
                    callLogout()
                  }}>Logout
                </Button>
              </DialogActions>
            </Dialog>
            <div className="w-100 p-3 left-nav">
              {!isAdmin ? menuItems.map((item: any, index: any) => {
                return (
                  <>
                    {
                      item.route === 'achievements' ? (
                        <>
                          {showAchievements && (
                            <ListItem
                              disabled={blockIntent && item.route !== 'orgsetting' && item.name !== 'Logout' ? true : false}
                              onClick={async () => {
                                // alert(item.route)
                                if (item.name.toLowerCase() === "logout") {
                                  handleopenClose(true);
                                } else {
                                  if (item.route) {
                                    // if (userType.toLowerCase().includes('admin') || userType.toLowerCase().includes('user')) {
                                    //   let data = await profileservice.profileStatus(sapCustomerId)
                                    //   if (data.data && !data.data.isActive) {
                                    //     setOpenDeactivatedDialog(data.data.deactivationReason)
                                    //   }
                                    //   if (data.data && data.data.tradepointAccessToCustomer === false) {
                                    //     setOpenTradepointAccessDialog("Please contact Al-Futtaim Sales Support for more information.")
                                    //   }
                                    // }
                                    history.push(item.route);
                                    if (item.route.includes('/oescatalogue')) {
                                      dispatch(openSideMenu(false));
                                    } else { dispatch(openSideMenu(true)); }
                                  }
                                }
                                setCurrentUrl(window.location.href);
                              }}
                              button
                              key={item.name}
                              className={currentUrl && currentUrl.includes(item.route) ? "active-menu" : ""}
                            >
                              <ListItemIcon>{item.icon}</ListItemIcon>
                              <ListItemText primary={item.name} />
                              {item.route === 'orderenquiry' && showCreateChangeEnquiry &&
                                <ListItemIcon>
                                  <IconButton className="p-1 ml-auto toast-header" edge="end" aria-label="add" onClick={(e) => {
                                    dispatch(resetEnquiryInfo());
                                    if (sessionStorage.getItem('userType') !== 'FSE') {
                                      loadProfileDetails();
                                    }
                                    e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                    sessionStorage.setItem('Order-log-UnReadCount', "")
                                    sessionStorage.setItem('Order-log-ReadCount', "")
                                    sessionStorage.setItem('reset-the-orderlog-count', "true");
                                    sessionStorage.setItem("isProblemParts", "");
                                    sessionStorage.setItem('subEnquiryId', "");
                                    sessionStorage.setItem("enquiry-current-status", "");
                                    sessionStorage.setItem('isCopyandCreate', "");
                                    sessionStorage.setItem("partsData", "")
                                    sessionStorage.setItem('isImportFromOES', 'false');
                                    sessionStorage.setItem('isUpdate', '');
                                    sessionStorage.setItem('viewEnquiry', "");
                                    sessionStorage.setItem('isAddedFromDashboard', 'false');
                                    sessionStorage.setItem('annexureEnquiry', "");
                                    history.push('/createenquiry');
                                    if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                    } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                      dispatch(getTBLPartsAPI());
                                    } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                      dispatch(getTBLPartsAPI());
                                    }
                                  }}>
                                    <AddCircleIcon fontSize="medium" />
                                  </IconButton>
                                </ListItemIcon>
                              }
                              {item.route === 'orgsetting' && expiredCount > 0 && profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType === "Admin" &&
                                <Tooltip title="Documents Pending for Renewal." placement="top">
                                  <Badge badgeContent={expiredCount} color="error">
                                  </Badge>
                                </Tooltip>
                              }
                            </ListItem>
                          )}
                        </>
                      ) : item.route === "annexurecreateenquiry" ?
                        (<>
                          <div className={classes2.root}>
                            <Accordion className="border-accordion">
                              <AccordionSummary
                                expandIcon={showCreateChangeEnquiry ? <ExpandMoreIcon /> : null}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                style={{ borderBottom: "none" }}
                                className="p-0 m-0"
                              >
                                <Typography className={classes2.heading}>
                                  < ListItem
                                    disabled={blockIntent && item.route !== 'orgsetting' && item.name !== 'Logout' ? true : false}
                                    onClick={async () => {
                                      // alert(item.route)
                                      if (item.name.toLowerCase() === "logout") {
                                        handleopenClose(true);
                                      } else {
                                        if (item.route === "annexurecreateenquiry") {
                                          history.push('/orderenquiry');
                                        } else if (item.route !== "annexurecreateenquiry") {
                                          // if (userType.toLowerCase().includes('admin') || userType.toLowerCase().includes('user')) {
                                          //   let data = await profileservice.profileStatus(sapCustomerId)
                                          //   if (data.data && !data.data.isActive) {
                                          //     setOpenDeactivatedDialog(data.data.deactivationReason)
                                          //   }
                                          //   if (data.data && data.data.tradepointAccessToCustomer === false) {
                                          //     setOpenTradepointAccessDialog("Please contact Al-Futtaim Sales Support for more information.")
                                          //   }
                                          // }
                                          history.push(item.route);
                                          if (item.route.includes('/oescatalogue')) {
                                            dispatch(openSideMenu(false));
                                          } else { dispatch(openSideMenu(true)); }
                                        }
                                      }
                                      setCurrentUrl(window.location.href);
                                    }}
                                    button
                                    key={item.name}
                                    className={currentUrl && currentUrl.includes(item.route) ? "active-menu" : ""}
                                  >
                                    <ListItemIcon>{item.icon}</ListItemIcon>
                                    <ListItemText primary={item.name} />
                                    {item.route === 'orderenquiry' && showCreateChangeEnquiry &&
                                      <ListItemIcon>
                                        <IconButton className="p-1 ml-auto toast-header" edge="end" aria-label="add" onClick={(e) => {
                                          dispatch(resetEnquiryInfo());
                                          loadProfileDetails();
                                          let enquiryStatusForInternalId: any = sessionStorage.getItem('Enquiry-Status')
                                          e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                          sessionStorage.setItem('Order-log-UnReadCount', "")
                                          sessionStorage.setItem('Order-log-ReadCount', "")
                                          sessionStorage.setItem('reset-the-orderlog-count', "true");
                                          sessionStorage.setItem("isProblemParts", "");
                                          sessionStorage.setItem("enquiry-current-status", "");
                                          sessionStorage.setItem('isCopyandCreate', "");
                                          sessionStorage.setItem("partsData", "")
                                          sessionStorage.setItem('subEnquiryId', "");
                                          sessionStorage.setItem('isImportFromOES', 'false');
                                          sessionStorage.setItem('isUpdate', '');
                                          sessionStorage.setItem('viewEnquiry', "");
                                          sessionStorage.setItem('isAddedFromDashboard', 'false');
                                          sessionStorage.setItem('annexureEnquiry', "");
                                          history.push('/createenquiry');
                                          if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                          } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                            dispatch(getTBLPartsAPI());
                                          } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                            dispatch(getTBLPartsAPI());
                                          }
                                        }}>
                                          <AddCircleIcon fontSize="medium" />
                                        </IconButton>
                                      </ListItemIcon>
                                    }
                                    {item.route === 'orgsetting' && expiredCount > 0 && profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType === "Admin" &&
                                      <Tooltip title="Documents Pending for Renewal." placement="top">
                                        <Badge badgeContent={expiredCount} color="error">
                                        </Badge>
                                      </Tooltip>
                                    }
                                  </ListItem>

                                  {/* <h5>Hello world</h5> */}
                                </Typography>
                              </AccordionSummary>
                              {showCreateChangeEnquiry &&
                                <AccordionDetails className="pt-0 mt-0">
                                  <Typography className="d-flex flex-row pl-4 mt-2 mb-2" onClick={(e) => {
                                    dispatch(resetEnquiryInfo());
                                    let enquiryStatusForInternalId: any = sessionStorage.getItem('Enquiry-Status')
                                    e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                    sessionStorage.setItem('Order-log-UnReadCount', "")
                                    sessionStorage.setItem('Order-log-ReadCount', "")
                                    sessionStorage.setItem('reset-the-orderlog-count', "true");
                                    sessionStorage.setItem("isProblemParts", "");
                                    sessionStorage.setItem("enquiry-current-status", "");
                                    sessionStorage.setItem('isCopyandCreate', "");
                                    sessionStorage.setItem("partsData", "")
                                    sessionStorage.setItem('subEnquiryId', "");
                                    sessionStorage.setItem('isImportFromOES', 'false');
                                    sessionStorage.setItem('isUpdate', '');
                                    sessionStorage.setItem('viewEnquiry', "");
                                    sessionStorage.setItem('isAddedFromDashboard', 'false');
                                    // sessionStorage.setItem('annexureEnquiry', "");
                                    history.push('/createenquiry');
                                    if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                    } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                      dispatch(getTBLPartsAPI());
                                    } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                      dispatch(getTBLPartsAPI());
                                    }
                                  }}>
                                    <>
                                      <p className="pl-3 pr-0 pt-1 font-catalogue" style={{ fontSize: "12px" }}>New Order Enquiry</p>
                                      <IconButton className="p-1 pr-3 ml-auto toast-header" edge="end" aria-label="add" onClick={(e) => {
                                        dispatch(resetEnquiryInfo());
                                        let enquiryStatusForInternalId: any = sessionStorage.getItem('Enquiry-Status')
                                        e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                        sessionStorage.setItem('Order-log-UnReadCount', "")
                                        sessionStorage.setItem('Order-log-ReadCount', "")
                                        sessionStorage.setItem('reset-the-orderlog-count', "true");
                                        sessionStorage.setItem("isProblemParts", "");
                                        sessionStorage.setItem("enquiry-current-status", "");
                                        sessionStorage.setItem('isCopyandCreate', "");
                                        sessionStorage.setItem("partsData", "")
                                        sessionStorage.setItem('subEnquiryId', "");
                                        sessionStorage.setItem('isImportFromOES', 'false');
                                        sessionStorage.setItem('isUpdate', '');
                                        sessionStorage.setItem('viewEnquiry', "");
                                        sessionStorage.setItem('isAddedFromDashboard', 'false');
                                        // sessionStorage.setItem('annexureEnquiry', "");
                                        history.push('/createenquiry');
                                        if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                        } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                          dispatch(getTBLPartsAPI());
                                        } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                          dispatch(getTBLPartsAPI());
                                        }
                                      }}>
                                        <AddCircleIcon fontSize="medium" />
                                      </IconButton>
                                    </>
                                  </Typography>
                                  <div>
                                    <Typography
                                      className="d-flex flex-row pl-4 mt-2 mb-2"
                                      onClick={async (e) => {
                                        dispatch(resetEnquiryInfo());
                                        await dispatch(getAllAnnexureList());
                                        let enquiryStatusForInternalId: any = sessionStorage.getItem('Enquiry-Status')
                                        e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                        sessionStorage.setItem('Order-log-UnReadCount', "")
                                        sessionStorage.setItem('Order-log-ReadCount', "")
                                        sessionStorage.setItem('reset-the-orderlog-count', "true");
                                        sessionStorage.setItem("isProblemParts", "");
                                        sessionStorage.setItem("enquiry-current-status", "");
                                        sessionStorage.setItem('isCopyandCreate', "");
                                        sessionStorage.setItem("partsData", "")
                                        sessionStorage.setItem('subEnquiryId', "");
                                        sessionStorage.setItem('isImportFromOES', 'false');
                                        sessionStorage.setItem('isUpdate', '');
                                        sessionStorage.setItem('viewEnquiry', "");
                                        sessionStorage.setItem('isAddedFromDashboard', 'false');
                                        // sessionStorage.setItem('annexureEnquiry', "true");
                                        // setAnnexurePartAdded(true);
                                        history.push('/annexurecreateenquiry');
                                        if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                        } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                          dispatch(getTBLPartsAPI());
                                        } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                          dispatch(getTBLPartsAPI());
                                        }
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <>
                                        <p className="pl-3 pt-1 font-catalogue" style={{ fontSize: "12px" }}>
                                          New Annexure/Core Product Enquiry
                                        </p>
                                        <IconButton className="p-1 pr-3 ml-auto toast-header" edge="end" aria-label="add"
                                          onClick={async (e) => {
                                            await dispatch(getAllAnnexureList());
                                            dispatch(resetEnquiryInfo());
                                            let enquiryStatusForInternalId: any = sessionStorage.getItem('Enquiry-Status')
                                            e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                            sessionStorage.setItem('Order-log-UnReadCount', "")
                                            sessionStorage.setItem('Order-log-ReadCount', "")
                                            sessionStorage.setItem('reset-the-orderlog-count', "true");
                                            sessionStorage.setItem("isProblemParts", "");
                                            sessionStorage.setItem("enquiry-current-status", "");
                                            sessionStorage.setItem('isCopyandCreate', "");
                                            sessionStorage.setItem("partsData", "")
                                            sessionStorage.setItem('subEnquiryId', "");
                                            sessionStorage.setItem('isImportFromOES', 'false');
                                            sessionStorage.setItem('isUpdate', '');
                                            sessionStorage.setItem('viewEnquiry', "");
                                            sessionStorage.setItem('isAddedFromDashboard', 'false');
                                            // sessionStorage.setItem('annexureEnquiry', "true");
                                            // setAnnexurePartAdded(true);
                                            history.push('/annexurecreateenquiry');
                                            if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                            } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                              dispatch(getTBLPartsAPI());
                                            } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                              dispatch(getTBLPartsAPI());
                                            }
                                          }}
                                        >
                                          <AddCircleIcon fontSize="medium" />
                                        </IconButton>
                                      </>
                                    </Typography>
                                  </div>
                                </AccordionDetails>
                              }
                            </Accordion>
                          </div>
                        </>) : item.route === "#" ?
                          (<>
                            <div className={classes2.root}>
                              <Accordion className="border-accordion">
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                  style={{ borderBottom: "none" }}
                                  className="p-0 m-0"
                                >
                                  <Typography className={classes2.heading}>
                                    <ListItem
                                      disabled={blockIntent && item.route !== 'orgsetting' && item.name !== 'Logout' ? true : false}
                                      onClick={async () => {
                                        // alert(item.route)
                                        if (item.name.toLowerCase() === "logout") {
                                          handleopenClose(true);
                                        } else {
                                          if (item.route) {
                                            if (userType.toLowerCase().includes('admin') || userType.toLowerCase().includes('user')) {
                                              let data = await profileservice.profileStatus(sapCustomerId)
                                              if (data.data && !data.data.isActive) {
                                                setOpenDeactivatedDialog(data.data.deactivationReason)
                                              }
                                              if (data.data && data.data.tradepointAccessToCustomer === false) {
                                                setOpenTradepointAccessDialog("Please contact Al-Futtaim Sales Support for more information.")
                                              }
                                            }
                                            history.push(item.route);
                                          }
                                        }
                                        setCurrentUrl(window.location.href);
                                      }}
                                      button
                                      key={item.name}
                                      className={currentUrl && currentUrl.includes(item.route) ? "active-menu" : ""}
                                    >
                                      <ListItemIcon className="">{item.icon}</ListItemIcon>
                                      <ListItemText primary={item.name} />
                                      {item.route === 'orderenquiry' && showCreateChangeEnquiry &&
                                        <ListItemIcon>
                                          <IconButton className="ml-auto toast-header" edge="end" aria-label="add" onClick={(e) => {
                                            if (sessionStorage.getItem('userType') !== 'FSE') {
                                              loadProfileDetails();
                                            } dispatch(resetEnquiryInfo());
                                            e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                            sessionStorage.setItem('Order-log-UnReadCount', "")
                                            sessionStorage.setItem('Order-log-ReadCount', "")
                                            sessionStorage.setItem("isProblemParts", "");
                                            sessionStorage.setItem('reset-the-orderlog-count', "true");
                                            sessionStorage.setItem('subEnquiryId', "");
                                            sessionStorage.setItem("enquiry-current-status", "");
                                            sessionStorage.setItem('isCopyandCreate', "");
                                            sessionStorage.setItem("partsData", "")
                                            sessionStorage.setItem('isImportFromOES', 'false');
                                            sessionStorage.setItem('isUpdate', '');
                                            sessionStorage.setItem('viewEnquiry', "");
                                            sessionStorage.setItem('isAddedFromDashboard', 'false');
                                            sessionStorage.setItem('annexureEnquiry', "");
                                            history.push('/createenquiry');
                                            if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                            } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                              dispatch(getTBLPartsAPI());
                                            } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                              dispatch(getTBLPartsAPI());
                                            }
                                          }}>
                                            <AddCircleIcon fontSize="medium" />
                                          </IconButton>
                                        </ListItemIcon>
                                      }
                                      {item.route === 'orgsetting' && expiredCount > 0 && profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType === "Admin" &&
                                        <Tooltip title="Documents Pending for Renewal." placement="top">
                                          <Badge badgeContent={expiredCount} color="error">
                                          </Badge>
                                        </Tooltip>
                                      }
                                    </ListItem>

                                    {/* <h5>Hello world</h5> */}
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails className="pt-0 mt-0">
                                  <Typography className="d-flex flex-row pl-4" onClick={() => { history.push("/oescatalogue"); if (window.location.href.includes('/oescatalogue')) { dispatch(openSideMenu(false)); } else { dispatch(openSideMenu(true)); } }}>
                                    <>
                                      <p style={{ color: "black", fontWeight: 500 }} className="pl-3"><ChevronRightRoundedIcon /></p>
                                      <p className="pl-3 pt-1 font-catalogue" style={{ fontSize: "12px" }}>OES Catalogue</p>
                                    </>
                                  </Typography>
                                </AccordionDetails>
                              </Accordion>
                            </div>
                          </>)
                          : item.route === "quotation" ? (
                            isAccessToQuotation() && <>
                              < ListItem
                                disabled={blockIntent && item.route !== 'orgsetting' && item.name !== 'Logout' ? true : false}
                                onClick={async () => {
                                  // alert(item.route)
                                  if (item.name.toLowerCase() === "logout") {
                                    handleopenClose(true);
                                  } else {
                                    if (item.route) {
                                      // if (userType.toLowerCase().includes('admin') || userType.toLowerCase().includes('user')) {
                                      //   let data = await profileservice.profileStatus(sapCustomerId)
                                      //   if (data.data && !data.data.isActive) {
                                      //     setOpenDeactivatedDialog(data.data.deactivationReason)
                                      //   }
                                      //   if (data.data && data.data.tradepointAccessToCustomer === false) {
                                      //     setOpenTradepointAccessDialog("Please contact Al-Futtaim Sales Support for more information.")
                                      //   }
                                      // }
                                      history.push(item.route);
                                      if (item.route.includes('/oescatalogue')) {
                                        dispatch(openSideMenu(false));
                                      } else { dispatch(openSideMenu(true)); }
                                    }
                                  }
                                  setCurrentUrl(window.location.href);
                                }}
                                button
                                key={item.name}
                                className={currentUrl && currentUrl.includes(item.route) ? "active-menu" : ""}
                              >
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.name} />
                                {item.route === 'orderenquiry' && showCreateChangeEnquiry &&
                                  <ListItemIcon>
                                    <IconButton className="p-1 ml-auto toast-header" edge="end" aria-label="add" onClick={(e) => {
                                      if (sessionStorage.getItem('userType') !== 'FSE') {
                                        loadProfileDetails();
                                      } dispatch(resetEnquiryInfo());
                                      e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                      sessionStorage.setItem('Order-log-UnReadCount', "")
                                      sessionStorage.setItem('Order-log-ReadCount', "")
                                      sessionStorage.setItem('reset-the-orderlog-count', "true");
                                      sessionStorage.setItem("isProblemParts", "");
                                      sessionStorage.setItem('subEnquiryId', "");
                                      sessionStorage.setItem('isCopyandCreate', "");
                                      sessionStorage.setItem("partsData", "")
                                      sessionStorage.setItem("enquiry-current-status", "");
                                      sessionStorage.setItem('isImportFromOES', 'false');
                                      sessionStorage.setItem('isUpdate', '');
                                      sessionStorage.setItem('viewEnquiry', "");
                                      sessionStorage.setItem('isAddedFromDashboard', 'false');
                                      sessionStorage.setItem('annexureEnquiry', "");
                                      history.push('/createenquiry');
                                      if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                      } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                        dispatch(getTBLPartsAPI());
                                      } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                        dispatch(getTBLPartsAPI());
                                      }
                                    }}>
                                      <AddCircleIcon fontSize="medium" />
                                    </IconButton>
                                  </ListItemIcon>
                                }
                                {item.route === 'orgsetting' && expiredCount > 0 && profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType === "Admin" &&
                                  <Tooltip title="Documents Pending for Renewal." placement="top">
                                    <Badge badgeContent={expiredCount} color="error">
                                    </Badge>
                                  </Tooltip>
                                }
                              </ListItem>
                            </>
                          ) : (
                            (
                              < ListItem
                                disabled={blockIntent && item.route !== 'orgsetting' && item.name !== 'Logout' ? true : false}
                                onClick={async () => {
                                  // alert(item.route)
                                  if (item.name.toLowerCase() === "logout") {
                                    handleopenClose(true);
                                  } else {
                                    if (item.route) {
                                      // if (userType.toLowerCase().includes('admin') || userType.toLowerCase().includes('user')) {
                                      //   let data = await profileservice.profileStatus(sapCustomerId)
                                      //   if (data.data && !data.data.isActive) {
                                      //     setOpenDeactivatedDialog(data.data.deactivationReason)
                                      //   }
                                      //   if (data.data && data.data.tradepointAccessToCustomer === false) {
                                      //     setOpenTradepointAccessDialog("Please contact Al-Futtaim Sales Support for more information.")
                                      //   }
                                      // }
                                      history.push(item.route);
                                      if (item.route.includes('/oescatalogue')) {
                                        dispatch(openSideMenu(false));
                                      } else { dispatch(openSideMenu(true)); }
                                    }
                                  }
                                  setCurrentUrl(window.location.href);
                                }}
                                button
                                key={item.name}
                                className={currentUrl && currentUrl.includes(item.route) ? "active-menu" : ""}
                              >
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.name} />
                                {item.route === 'orderenquiry' && showCreateChangeEnquiry &&
                                  <ListItemIcon>
                                    <IconButton className="p-1 ml-auto toast-header" edge="end" aria-label="add" onClick={(e) => {
                                      if (sessionStorage.getItem('userType') !== 'FSE') {
                                        loadProfileDetails();
                                      }
                                      dispatch(resetEnquiryInfo());
                                      let enquiryStatusForInternalId: any = sessionStorage.getItem('Enquiry-Status')
                                      e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                      sessionStorage.setItem('Order-log-UnReadCount', "")
                                      sessionStorage.setItem('Order-log-ReadCount', "")
                                      sessionStorage.setItem('reset-the-orderlog-count', "true");
                                      sessionStorage.setItem("isProblemParts", "");
                                      sessionStorage.setItem("enquiry-current-status", "");
                                      sessionStorage.setItem('isCopyandCreate', "");
                                      sessionStorage.setItem("partsData", "")
                                      sessionStorage.setItem('subEnquiryId', "");
                                      sessionStorage.setItem('isImportFromOES', 'false');
                                      sessionStorage.setItem('isUpdate', '');
                                      sessionStorage.setItem('viewEnquiry', "");
                                      sessionStorage.setItem('isAddedFromDashboard', 'false');
                                      sessionStorage.setItem('annexureEnquiry', "");
                                      history.push('/createenquiry');
                                      if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                      } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                        dispatch(getTBLPartsAPI());
                                      } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                        dispatch(getTBLPartsAPI());
                                      }
                                    }}>
                                      <AddCircleIcon fontSize="medium" />
                                    </IconButton>
                                  </ListItemIcon>
                                }
                                {item.route === 'orgsetting' && expiredCount > 0 && profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType === "Admin" &&
                                  <Tooltip title="Documents Pending for Renewal." placement="top">
                                    <Badge badgeContent={expiredCount} color="error">
                                    </Badge>
                                  </Tooltip>
                                }
                              </ListItem>
                            )
                          )
                    }
                  </>
                );
              }) : adminMenuItems.map((item: any, index: any) => {

                return (
                  <>
                    {item.route === "#" ?
                      (<>
                        <div className={classes2.root}>
                          <Accordion className="border-accordion">
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                              style={{ borderBottom: "none" }}
                              className="p-0 m-0"
                            >
                              <Typography className={classes2.heading}>
                                <ListItem
                                  onClick={async () => {
                                    // alert(item.route)
                                    if (item.name.toLowerCase() === "logout") {
                                      handleopenClose(true);
                                    } else {
                                      if (item.route) {
                                        if (userType.toLowerCase().includes('admin') || userType.toLowerCase().includes('user') || userType.toLowerCase().includes('fse')) {
                                          let data = await profileservice.profileStatus(sapCustomerId)
                                          if (data.data && !data.data.isActive) {
                                            setOpenDeactivatedDialog(data.data.deactivationReason)
                                          }
                                          if (data.data && data.data.tradepointAccessToCustomer === false) {
                                            setOpenTradepointAccessDialog("Please contact Al-Futtaim Sales Support for more information.")
                                          }
                                        }
                                        history.push(item.route);
                                      }
                                    }
                                    setCurrentUrl(window.location.href);
                                  }}
                                  button
                                  key={item.name}
                                  className={currentUrl && currentUrl.includes(item.route) ? "active-menu" : ""}
                                >
                                  <ListItemIcon className="">{item.icon}</ListItemIcon>
                                  <ListItemText primary={item.name} />
                                  {item.route === 'orderenquiry' && showCreateChangeEnquiry &&
                                    <ListItemIcon>
                                      <IconButton className="ml-auto toast-header" edge="end" aria-label="add" onClick={(e) => {
                                        if (sessionStorage.getItem('userType') !== 'FSE') {
                                          loadProfileDetails();
                                        }
                                        dispatch(resetEnquiryInfo());
                                        e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                        sessionStorage.setItem('Order-log-UnReadCount', "")
                                        sessionStorage.setItem('subEnquiryId', "");
                                        sessionStorage.setItem('Order-log-ReadCount', "")
                                        sessionStorage.setItem("isProblemParts", "");
                                        sessionStorage.setItem('reset-the-orderlog-count', "true");
                                        sessionStorage.setItem("enquiry-current-status", "");
                                        sessionStorage.setItem('isCopyandCreate', "");
                                        sessionStorage.setItem("partsData", "")
                                        sessionStorage.setItem('isImportFromOES', 'false');
                                        sessionStorage.setItem('isUpdate', '');
                                        sessionStorage.setItem('viewEnquiry', "");
                                        sessionStorage.setItem('isAddedFromDashboard', 'false');
                                        sessionStorage.setItem('annexureEnquiry', "");
                                        history.push('/createenquiry');
                                        if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                        } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                          dispatch(getTBLPartsAPI());
                                        } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                          dispatch(getTBLPartsAPI());
                                        }
                                      }}>
                                        <AddCircleIcon fontSize="medium" />
                                      </IconButton>
                                    </ListItemIcon>
                                  }
                                </ListItem>

                                {/* <h5>Hello world</h5> */}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails className="pt-0 mt-0">
                              <Typography className="d-flex flex-row pl-4" onClick={() => { history.push("/oescatalogue"); if (window.location.href.includes('/oescatalogue')) { dispatch(openSideMenu(false)); } else { dispatch(openSideMenu(true)); } }}>
                                <>
                                  <p style={{ color: "black", fontWeight: 500 }} className="pl-3"><ChevronRightRoundedIcon /></p>
                                  <p className="pl-3 pt-1 font-catalogue" style={{ fontSize: "12px" }}>OES Catalogue</p>
                                </>
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </>)
                      : item.route === "annexurecreateenquiry" ?
                        (<>
                          <div className={classes2.root}>
                            <Accordion className="border-accordion">
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                style={{ borderBottom: "none" }}
                                className="p-0 m-0"
                              >
                                <Typography className={classes2.heading}>
                                  < ListItem
                                    disabled={blockIntent && item.route !== 'orgsetting' && item.name !== 'Logout' ? true : false}
                                    onClick={async () => {
                                      // alert(item.route)
                                      if (item.name.toLowerCase() === "logout") {
                                        handleopenClose(true);
                                      } else {
                                        if (item.route === "annexurecreateenquiry") {
                                          history.push('/orderenquiry');
                                        } else if (item.route !== "annexurecreateenquiry") {
                                          // if (userType.toLowerCase().includes('admin') || userType.toLowerCase().includes('user')) {
                                          //   let data = await profileservice.profileStatus(sapCustomerId)
                                          //   if (data.data && !data.data.isActive) {
                                          //     setOpenDeactivatedDialog(data.data.deactivationReason)
                                          //   }
                                          //   if (data.data && data.data.tradepointAccessToCustomer === false) {
                                          //     setOpenTradepointAccessDialog("Please contact Al-Futtaim Sales Support for more information.")
                                          //   }
                                          // }
                                          history.push(item.route);
                                          if (item.route.includes('/oescatalogue')) {
                                            dispatch(openSideMenu(false));
                                          } else { dispatch(openSideMenu(true)); }
                                        }
                                      }
                                      setCurrentUrl(window.location.href);
                                    }}
                                    button
                                    key={item.name}
                                    className={currentUrl && currentUrl.includes(item.route) ? "active-menu" : ""}
                                  >
                                    <ListItemIcon>{item.icon}</ListItemIcon>
                                    <ListItemText primary={item.name} />
                                    {item.route === 'orderenquiry' && showCreateChangeEnquiry &&
                                      <ListItemIcon>
                                        <IconButton className="p-1 ml-auto toast-header" edge="end" aria-label="add" onClick={(e) => {
                                          dispatch(resetEnquiryInfo());
                                          let enquiryStatusForInternalId: any = sessionStorage.getItem('Enquiry-Status')
                                          e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                          sessionStorage.setItem('Order-log-UnReadCount', "")
                                          sessionStorage.setItem('Order-log-ReadCount', "")
                                          sessionStorage.setItem('reset-the-orderlog-count', "true");
                                          sessionStorage.setItem("isProblemParts", "");
                                          sessionStorage.setItem("enquiry-current-status", "");
                                          sessionStorage.setItem('isCopyandCreate', "");
                                          sessionStorage.setItem("partsData", "")
                                          sessionStorage.setItem('subEnquiryId', "");
                                          sessionStorage.setItem('isImportFromOES', 'false');
                                          sessionStorage.setItem('isUpdate', '');
                                          sessionStorage.setItem('viewEnquiry', "");
                                          sessionStorage.setItem('isAddedFromDashboard', 'false');
                                          sessionStorage.setItem('annexureEnquiry', "");
                                          history.push('/createenquiry');
                                          if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                          } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                            dispatch(getTBLPartsAPI());
                                          } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                            dispatch(getTBLPartsAPI());
                                          }
                                        }}>
                                          <AddCircleIcon fontSize="medium" />
                                        </IconButton>
                                      </ListItemIcon>
                                    }
                                    {item.route === 'orgsetting' && expiredCount > 0 && profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType === "Admin" &&
                                      <Tooltip title="Documents Pending for Renewal." placement="top">
                                        <Badge badgeContent={expiredCount} color="error">
                                        </Badge>
                                      </Tooltip>
                                    }
                                  </ListItem>

                                  {/* <h5>Hello world</h5> */}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails className="pt-0 mt-0">
                                <Typography className="d-flex flex-row pl-4 mt-2 mb-2"
                                  onClick={(e) => {
                                    sessionStorage.setItem('isImportFromOES', 'false');
                                    sessionStorage.setItem('isUpdate', '')
                                    if (sessionStorage.getItem('userType') === 'FSE' || userType === "FSE" || sessionStorage.getItem('userType') === 'sre') {
                                      if (window.location.pathname.includes('createenquiry')) {
                                        handleChooseCustomer();
                                      }
                                      // handleChooseCustomer();
                                      // sessionStorage.setItem('annexureEnquiry', "");
                                      history.push('/createenquiry');
                                      setAnnexurePartAdded(false);
                                      // handleChooseCustomerIWSFSEDialog();
                                      setLoading(true);
                                      let data: any = dispatch(getFSECustomerList('customerListOnFsePortalForEnquiry'));
                                      if (data && data.error) {
                                        setErrorMessage(data && data.error);
                                        handleopenCloseErrorSnackbar(true);
                                        setLoading(false);
                                      } else {
                                        handleopenCloseErrorSnackbar(false);
                                        setLoading(false);
                                      }
                                      setLoading(false);
                                      e.stopPropagation();
                                      // dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                    } else {
                                      dispatch(resetEnquiryInfo());
                                      e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                      sessionStorage.setItem('Order-log-UnReadCount', "")
                                      sessionStorage.setItem('Order-log-ReadCount', "")
                                      sessionStorage.setItem('reset-the-orderlog-count', "true")
                                      sessionStorage.setItem("isProblemParts", "");
                                      sessionStorage.setItem('subEnquiryId', "");
                                      sessionStorage.setItem("enquiry-current-status", "");
                                      sessionStorage.setItem('isCopyandCreate', "");
                                      sessionStorage.setItem("partsData", "");
                                      sessionStorage.setItem('isImportFromOES', 'false');
                                      sessionStorage.setItem('isUpdate', '');
                                      sessionStorage.setItem('viewEnquiry', "");
                                      sessionStorage.setItem('isAddedFromDashboard', 'false');
                                      sessionStorage.setItem('annexureEnquiry', "false");
                                      history.push('/createenquiry');
                                      if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                      } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                        dispatch(getTBLPartsAPI());
                                      } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                        dispatch(getTBLPartsAPI());
                                      }
                                    }
                                  }}>
                                  <>
                                    <p className="pl-3 pr-0 pt-1 font-catalogue" style={{ fontSize: "12px" }}>New Order Enquiry</p>
                                    <IconButton className="p-1 pr-3 ml-auto toast-header" edge="end" aria-label="add"
                                      onClick={(e) => {
                                        sessionStorage.setItem('isImportFromOES', 'false');
                                        sessionStorage.setItem('isUpdate', '')
                                        if (sessionStorage.getItem('userType') === 'FSE' || userType === "FSE" || sessionStorage.getItem('userType') === 'sre') {
                                          if (window.location.pathname.includes('createenquiry')) {
                                            handleChooseCustomer();
                                          }

                                          // handleChooseCustomer();
                                          // sessionStorage.setItem('annexureEnquiry', "");
                                          history.push('/createenquiry');
                                          setAnnexurePartAdded(false);
                                          // handleChooseCustomerIWSFSEDialog();
                                          setLoading(true);
                                          let data: any = dispatch(getFSECustomerList('customerListOnFsePortalForEnquiry'));
                                          if (data && data.error) {
                                            setErrorMessage(data && data.error);
                                            handleopenCloseErrorSnackbar(true);
                                            setLoading(false);
                                          } else {
                                            handleopenCloseErrorSnackbar(false);
                                            setLoading(false);
                                          }
                                          setLoading(false);
                                          e.stopPropagation();
                                          // dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                        } else {
                                          dispatch(resetEnquiryInfo());
                                          e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                          sessionStorage.setItem('Order-log-UnReadCount', "")
                                          sessionStorage.setItem('Order-log-ReadCount', "")
                                          sessionStorage.setItem('reset-the-orderlog-count', "true")
                                          sessionStorage.setItem("isProblemParts", "");
                                          sessionStorage.setItem('subEnquiryId', "");
                                          sessionStorage.setItem("enquiry-current-status", "");
                                          sessionStorage.setItem('isCopyandCreate', "");
                                          sessionStorage.setItem("partsData", "");
                                          sessionStorage.setItem('isImportFromOES', 'false');
                                          sessionStorage.setItem('isUpdate', '');
                                          sessionStorage.setItem('viewEnquiry', "");
                                          sessionStorage.setItem('isAddedFromDashboard', 'false');
                                          sessionStorage.setItem('annexureEnquiry', "false");
                                          history.push('/createenquiry');
                                          if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                          } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                            dispatch(getTBLPartsAPI());
                                          } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                            dispatch(getTBLPartsAPI());
                                          }
                                        }
                                      }}>
                                      <AddCircleIcon fontSize="medium" />
                                    </IconButton>
                                  </>
                                </Typography>
                                <div>
                                  <Typography
                                    className="d-flex flex-row pl-4 mt-2 mb-2"
                                    onClick={async (e) => {
                                      e.stopPropagation();
                                      await dispatch(getAllAnnexureList());
                                      sessionStorage.setItem('isImportFromOES', 'false');
                                      sessionStorage.setItem('isUpdate', '')
                                      if (sessionStorage.getItem('userType') === 'FSE' || userType === "FSE" || sessionStorage.getItem('userType') === 'sre') {
                                        handleChooseCustomer();
                                        // sessionStorage.setItem('annexureEnquiry', "true");
                                        setAnnexurePartAdded(true);
                                        history.push('/annexurecreateenquiry');
                                        // handleChooseCustomerIWSFSEDialog();
                                        setLoading(true);
                                        let data: any = dispatch(getFSECustomerList('customersWithAnnexureAccess'));
                                        if (data && data.error) {
                                          setErrorMessage(data && data.error);
                                          handleopenCloseErrorSnackbar(true);
                                          setLoading(false);
                                        } else {
                                          handleopenCloseErrorSnackbar(false);
                                          setLoading(false);
                                        }
                                        setLoading(false);
                                        e.stopPropagation();
                                        // dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                      } else {
                                        dispatch(resetEnquiryInfo());
                                        e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                        sessionStorage.setItem('Order-log-UnReadCount', "")
                                        sessionStorage.setItem('Order-log-ReadCount', "")
                                        sessionStorage.setItem('reset-the-orderlog-count', "true")
                                        sessionStorage.setItem("isProblemParts", "");
                                        sessionStorage.setItem('subEnquiryId', "");
                                        sessionStorage.setItem("enquiry-current-status", "");
                                        sessionStorage.setItem('isCopyandCreate', "");
                                        sessionStorage.setItem("partsData", "");
                                        sessionStorage.setItem('isImportFromOES', 'false');
                                        sessionStorage.setItem('isUpdate', '');
                                        sessionStorage.setItem('viewEnquiry', "");
                                        sessionStorage.setItem('isAddedFromDashboard', 'false');
                                        sessionStorage.setItem('annexureEnquiry', "true");
                                        setAnnexurePartAdded(true);
                                        history.push('/annexurecreateenquiry');
                                        if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                        } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                          dispatch(getTBLPartsAPI());
                                        } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                          dispatch(getTBLPartsAPI());
                                        }
                                      }
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <>
                                      <p className="pl-3 pr-0 pt-1 font-catalogue" style={{ fontSize: "12px" }}>
                                        New Annexure/Core Products
                                      </p>
                                      <IconButton className="p-1 pr-3 ml-auto toast-header" edge="end" aria-label="add"
                                        onClick={async (e) => {
                                          e.stopPropagation();
                                          sessionStorage.setItem('isImportFromOES', 'false');
                                          if (sessionStorage.getItem('userType') !== 'FSE') {
                                            loadProfileDetails();
                                          }
                                          await dispatch(getAllAnnexureList());
                                          sessionStorage.setItem('isUpdate', '')
                                          if (sessionStorage.getItem('userType') === 'FSE' || userType === "FSE" || sessionStorage.getItem('userType') === 'sre') {
                                            handleChooseCustomer();
                                            // sessionStorage.setItem('annexureEnquiry', "true");
                                            setAnnexurePartAdded(true);
                                            history.push('/annexurecreateenquiry');
                                            // handleChooseCustomerIWSFSEDialog();
                                            setLoading(true);
                                            let data: any = dispatch(getFSECustomerList('customersWithAnnexureAccess'));
                                            if (data && data.error) {
                                              setErrorMessage(data && data.error);
                                              handleopenCloseErrorSnackbar(true);
                                              setLoading(false);
                                            } else {
                                              handleopenCloseErrorSnackbar(false);
                                              setLoading(false);
                                            }
                                            setLoading(false);
                                            e.stopPropagation();
                                            // dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                          } else {
                                            dispatch(resetEnquiryInfo());
                                            e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                            sessionStorage.setItem('Order-log-UnReadCount', "")
                                            sessionStorage.setItem('Order-log-ReadCount', "")
                                            sessionStorage.setItem('reset-the-orderlog-count', "true")
                                            sessionStorage.setItem("isProblemParts", "");
                                            sessionStorage.setItem('subEnquiryId', "");
                                            sessionStorage.setItem("enquiry-current-status", "");
                                            sessionStorage.setItem('isCopyandCreate', "");
                                            sessionStorage.setItem("partsData", "");
                                            sessionStorage.setItem('isImportFromOES', 'false');
                                            sessionStorage.setItem('isUpdate', '');
                                            sessionStorage.setItem('viewEnquiry', "");
                                            sessionStorage.setItem('isAddedFromDashboard', 'false');
                                            sessionStorage.setItem('annexureEnquiry', "true");
                                            setAnnexurePartAdded(true);
                                            history.push('/annexurecreateenquiry');
                                            if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                            } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                              dispatch(getTBLPartsAPI());
                                            } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                              dispatch(getTBLPartsAPI());
                                            }
                                          }
                                        }}
                                      >
                                        <AddCircleIcon fontSize="medium" />
                                      </IconButton>
                                    </>
                                  </Typography>
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          </div>
                        </>) :
                        <ListItem
                          onClick={async () => {
                            if (item.name.toLowerCase() === "logout") {
                              handleopenClose(true);
                            } else {
                              if (item.route) {
                                // if (item.route === "creditlist") {
                                //   dispatch(getAllCreditRequestStatus('kam'));
                                // }
                                history.push(item.route);
                              }
                            }
                            setCurrentUrl(window.location.href);
                            dispatch(setTabValue(0));
                          }}
                          button
                          key={item.name}
                          className={currentUrl && currentUrl.includes(item.route) ? "active-menu" : ""}
                        >
                          <ListItemIcon>{currentUrl && currentUrl.includes(item.route) ? item.selectedIcon ? item.selectedIcon : item.icon : item.icon}</ListItemIcon>
                          <ListItemText primary={item.name} />
                          {item.route === 'orderenquiry' &&
                            <ListItemIcon>
                              <IconButton className="p-1 ml-auto toast-header" edge="end" aria-label="add" onClick={(e) => {
                                sessionStorage.setItem('isImportFromOES', 'false');
                                sessionStorage.setItem('isUpdate', '')
                                if (sessionStorage.getItem('userType') !== 'FSE') {
                                  loadProfileDetails();
                                }
                                if (sessionStorage.getItem('userType') === 'FSE' || userType === "FSE" || sessionStorage.getItem('userType') === 'sre') {
                                  if (window.location.pathname.includes('createenquiry')) {
                                    handleChooseCustomer();
                                  }
                                  // handleChooseCustomerIWSFSEDialog();
                                  history.push('/createenquiry');
                                  setLoading(true);
                                  let data: any = dispatch(getFSECustomerList('customerListOnFsePortalForEnquiry'));
                                  if (data && data.error) {
                                    setErrorMessage(data && data.error);
                                    handleopenCloseErrorSnackbar(true);
                                    setLoading(false);
                                  } else {
                                    handleopenCloseErrorSnackbar(false);
                                    setLoading(false);
                                  }
                                  setLoading(false);
                                  e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                } else {
                                  dispatch(resetEnquiryInfo());
                                  e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                  sessionStorage.setItem('Order-log-UnReadCount', "")
                                  sessionStorage.setItem('Order-log-ReadCount', "")
                                  sessionStorage.setItem('reset-the-orderlog-count', "true")
                                  sessionStorage.setItem("isProblemParts", "");
                                  sessionStorage.setItem('subEnquiryId', "");
                                  sessionStorage.setItem("enquiry-current-status", "");
                                  sessionStorage.setItem('isCopyandCreate', "");
                                  sessionStorage.setItem("partsData", "");
                                  sessionStorage.setItem('isImportFromOES', 'false');
                                  sessionStorage.setItem('isUpdate', '');
                                  sessionStorage.setItem('viewEnquiry', "");
                                  sessionStorage.setItem('isAddedFromDashboard', 'false');
                                  sessionStorage.setItem('annexureEnquiry', "");
                                  history.push('/createenquiry');
                                  if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                  } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                    dispatch(getTBLPartsAPI());
                                  } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                    dispatch(getTBLPartsAPI());
                                  }
                                }
                              }}>
                                <AddCircleIcon fontSize="medium" />
                              </IconButton>
                            </ListItemIcon>
                          }
                          {item.route === 'dealers' &&
                            <ListItemIcon hidden>
                              <IconButton className="p-0 m-1 toast-header" edge="end" aria-label="add" onClick={(e) => {
                                sessionStorage.setItem('isImportFromOES', 'false');
                                sessionStorage.setItem('isUpdate', '')
                                if (sessionStorage.getItem('userType') !== 'FSE') {
                                  loadProfileDetails();
                                }
                                if (sessionStorage.getItem('userType') === 'FSE' || userType === "FSE") {
                                  handleChooseCustomer();
                                  handleChooseCustomerIWSFSEDialog();
                                  e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                  if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                  } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                    dispatch(getTBLPartsAPI());
                                  } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                    dispatch(getTBLPartsAPI());
                                  }
                                } else {
                                  dispatch(resetEnquiryInfo());
                                  e.stopPropagation(); dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
                                  sessionStorage.setItem('Order-log-UnReadCount', "")
                                  sessionStorage.setItem('Order-log-ReadCount', "")
                                  sessionStorage.setItem("isProblemParts", "");
                                  sessionStorage.setItem('reset-the-orderlog-count', "true");
                                  sessionStorage.setItem('subEnquiryId', "");
                                  sessionStorage.setItem("enquiry-current-status", "");
                                  sessionStorage.setItem('isCopyandCreate', "");
                                  sessionStorage.setItem("partsData", "")
                                  sessionStorage.setItem('isImportFromOES', 'false');
                                  sessionStorage.setItem('isUpdate', '');
                                  sessionStorage.setItem('viewEnquiry', "");
                                  sessionStorage.setItem('isAddedFromDashboard', 'false');
                                  sessionStorage.setItem('annexureEnquiry', "");
                                  history.push('/createenquiry');
                                  if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && !tblDealerAccess.includes("Tyres")) {
                                  } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                    dispatch(getTBLPartsAPI());
                                  } else if (customerTierType === 'TBL Dealer' && Array.isArray(tblDealerAccess) && !tblDealerAccess.includes("Parts") && tblDealerAccess.includes("Tyres")) {
                                    dispatch(getTBLPartsAPI());
                                  }
                                }
                              }}>
                                <AddCircleIcon fontSize="medium" />
                              </IconButton>
                            </ListItemIcon>
                          }
                        </ListItem>}
                  </>
                );
              })}
              {!isAdmin && (
                <div className="font-12 mt-2">
                  {markupPercentage && parseFloat(markupPercentage) > 0 && displayPrice && displayPrice.length > 0 && displayPrice[0].value === false && percentageForSellingPrice && (
                    <Typography component="div" className="ml-5 mb-4">
                      <Grid component="label" container alignItems="center" spacing={1}>
                        {menuItems && menuItems[0] && menuItems[0]['name'] !== "Special Price Request" && <Grid item>
                          <AntSwitch
                            checked={isSellingPriceData}
                            onChange={(e) => {
                              dispatch(isSellingPrice(e.target.checked));
                            }}
                          />
                        </Grid>}
                      </Grid>
                    </Typography>
                  )}
                </div>
              )}
              {userType != "PRODUCT_TEAM" ?
                <div className="font-12 mt-2 copyright">
                  {profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo ?
                    <Button
                      disabled={profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo.userType === 'guestAdmin' || blockIntent === true ? true : false}
                      onClick={(e: any) => {
                        if (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo.userType !== 'guestAdmin') {
                          setOpenCloseSupportDialog(true);
                        }
                      }}
                      style={{ cursor: 'pointer' }} className="text-muted mr-2">Support</Button> :
                    <Button
                      disabled={blockIntent === true ? true : false}
                      onClick={(e: any) => {
                        e.preventDefault();
                      }}
                      className="text-muted mr-2">Support</Button>}
                  |  <Button
                    disabled={blockIntent === true ? true : false}
                    onClick={() => handleOpenCloseTAndC(true)} style={{ cursor: 'pointer' }}
                    className="text-muted ml-2">T &amp; C
                  </Button>
                  <div className="text-muted mt-1">© 2021 Al-Futtaim. All rights reserved</div>
                  {customerTierType === "Workshop" || customerTierType === 'tpcdealer' && (
                    <div>
                      <img className="ml-n2 mt-2" alt="credit card icon" width="260px"
                        src={creditcardicon} />
                    </div>
                  )}
                </div> :
                <div className="font-12 mt-2 copyright copyright-prod-team">
                  <Button
                    disabled={blockIntent === true ? true : false}
                    onClick={() => handleOpenCloseTAndC(true)} style={{ cursor: 'pointer' }}
                    className="text-muted terms-cond-btn">T &amp; C
                  </Button>
                  <div className="text-muted mt-1">© 2021 Al-Futtaim. All rights reserved</div>
                  {customerTierType === "Workshop" && (
                    <div>
                      <img className="ml-n2 mt-2" alt="credit card icon" width="260px"
                        src={creditcardicon} />
                    </div>
                  )}
                </div>}
            </div>
            <BlackoutDialog
              open={showBlackoutPopUp}
              handleopenClose={(data: any) => { setShowBlackoutPopUp(data ? true : false) }}
              blackOutPopUpData={blackOutPopUpData}
            />
            <TermsAndConditionsDialog
              open={openTAndCDialog}
              handleopenClose={() => {
                handleOpenCloseTAndC(false)
              }}
              handleLoader={handleLoader}
            />
            <DocumentExpiryStatus
              open={showDeactivateDialog}
              handleopenClose={(data: any) => {
                setshowDeactivateDialog(data ? true : false)
              }} />
            <SupportDialog
              openCloseSupportDialog={openCloseSupportDialog}
              setOpenCloseSupportDialog={setOpenCloseSupportDialog}
            ></SupportDialog>
          </Drawer>
          {
            !leftMenuVisibility && (
              <>
                <div className="px-2 mt-3 align-items-center text-center">
                  <IconButton
                    onClick={() => {
                      dispatch(openSideMenu(true));
                    }}
                  >
                    <MenuIcon />
                  </IconButton>
                </div>
                ` <div className="pt-3 pb-4 text-center">
                  <img src={smallLogoicon} alt="Logo" className="h-28" />
                </div>
                <div className="media bg-primary py-3 px-1">
                  <img className="rounded-circle hw-45 ml-2" src={(userType === userTypes.kam || userType === userTypes.fse || userType === "product_team") ? tempKamLogo : dealerLogo ? dealerLogo : userType === "PRODUCT_TEAM" ? ProductTeamNoImage : NoImage} alt="Logo" />
                </div>
                <div className="w-100 p-2 left-nav">
                  {!isAdmin ? menuItems.map((item: any, index: any) => {
                    return (
                      <>
                        {item.route === 'achievements' ? (
                          <>
                            {showAchievements && (
                              <Tooltip title={item.name} placement="right">
                                <ListItem
                                  disabled={blockIntent && item.route !== 'orgsetting' && item.name !== 'Logout' ? true : false}
                                  onClick={async () => {
                                    if (item.name.toLowerCase() === "logout") {
                                      handleopenClose(true);
                                    } else {
                                      if (item.route) {
                                        history.push(item.route);
                                        if (item.route.includes('/oescatalogue')) {
                                          dispatch(openSideMenu(false));
                                        } else { dispatch(openSideMenu(true)); }
                                      }
                                    }
                                    setCurrentUrl(window.location.href);
                                  }}
                                  button
                                  key={item.name}
                                  className={currentUrl && currentUrl.includes(item.route) ? "active-menu mb-2" : "mb-2"}
                                >
                                  <ListItemIcon>{item.icon}</ListItemIcon>
                                </ListItem>
                              </Tooltip>
                            )}
                          </>
                        ) : (
                          <Tooltip title={item.name} placement="right">
                            <ListItem
                              disabled={blockIntent && item.route !== 'orgsetting' && item.name !== 'Logout' ? true : false}
                              onClick={async () => {
                                if (item.name.toLowerCase() === "logout") {
                                  handleopenClose(true);
                                } else {
                                  if (item.route) {
                                    history.push(item.route);
                                    if (item.route.includes('/oescatalogue')) {
                                      dispatch(openSideMenu(false));
                                    } else { dispatch(openSideMenu(true)); }
                                  }
                                }
                                setCurrentUrl(window.location.href);
                              }}
                              button
                              key={item.name}
                              className={currentUrl && currentUrl.includes(item.route) ? "active-menu mb-2" : "mb-2"}
                            >
                              <ListItemIcon>{item.icon}</ListItemIcon>
                            </ListItem>
                          </Tooltip>
                        )}
                      </>
                    );
                  }) : adminMenuItems.map((item: any, index: any) => {
                    return (
                      <Tooltip title={item.name} placement="right">
                        <ListItem
                          disabled={blockIntent && item.route !== 'orgsetting' && item.name !== 'Logout' ? true : false}
                          onClick={async () => {
                            sessionStorage.setItem('isImportFromOES', 'false');
                            sessionStorage.setItem('isUpdate', '');
                            sessionStorage.setItem('isAddedFromDashboard', 'false');
                            if (item.name.toLowerCase() === "logout") {
                              handleopenClose(true);
                            } else {
                              if (item.route) {
                                history.push(item.route);
                              }
                            }
                            setCurrentUrl(window.location.href);
                            dispatch(setTabValue(0));
                          }}
                          button
                          key={item.name}
                          className={currentUrl && currentUrl.includes(item.route) ? "active-menu mb-2" : "mb-2"}
                        >
                          <ListItemIcon>{currentUrl && currentUrl.includes(item.route) ? item.selectedIcon ? item.selectedIcon : item.icon : item.icon}</ListItemIcon>
                          {item.route === 'dealers' &&
                            <ListItemIcon hidden>
                              <IconButton className="p-0 m-1 toast-header" edge="end" aria-label="add">
                                <AddCircleIcon fontSize="medium" />
                              </IconButton>
                            </ListItemIcon>
                          }
                        </ListItem>
                      </Tooltip>
                    )
                  })}
                </div >
              </>
            )
          }
        </div >
      }
      {openChooseCustomerDialog && <ChooseCustomerDialog annexurePartAdded={annexurePartAdded} openChooseCustomerDialog={openChooseCustomerDialog} openCloseChooseCustomer={openCloseChooseCustomer} isOrderEnquiryCreated={isOrderEnquiryCreated} />}
      {/* {iwsFseOpenChooseCustomerDialog && <IWSFSEChooseCustomerDialog iwsFseOpenChooseCustomerDialog={iwsFseOpenChooseCustomerDialog} openCloseChooseCustomerIWSFSEDialog={openCloseChooseCustomerIWSFSEDialog} />} */}
      <LogoutDialog
        open={openLogoutDialog}
        text="Are you sure to logout?"
        handleopenClose={() => {
          handleopenClose(false)
        }} />
      <PricingTierDowngradeDialog open={showPricingTierDialog} handleopenClose={setShowPricingTierDialog} />
    </Fragment >
  );
};

export default LeftMenu;
